export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  /** All scalar types */
  scalar: any;
};

export type Actions = {
  __typename?: 'Actions';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type AddToCartMutation = {
  __typename?: 'AddToCartMutation';
  cart?: Maybe<Cart>;
  message?: Maybe<Scalars['String']>;
};

export type AlgoliaFilter = {
  __typename?: 'AlgoliaFilter';
  algoliaAttribute?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  instantSearchType?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  sortStrategy?: Maybe<Scalars['String']>;
};

export type AlgoliaFiltersAndSorts = {
  __typename?: 'AlgoliaFiltersAndSorts';
  filters?: Maybe<Array<Maybe<AlgoliaFilter>>>;
  sorts?: Maybe<Array<Maybe<AlgoliaSort>>>;
};

export type AlgoliaSort = {
  __typename?: 'AlgoliaSort';
  id?: Maybe<Scalars['ID']>;
  indexName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Area = {
  __typename?: 'Area';
  contentImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  urlPath?: Maybe<Scalars['String']>;
};

export type Attribute = {
  __typename?: 'Attribute';
  code: Scalars['String'];
  value?: Maybe<Scalars['scalar']>;
};

export type AttributeBase = {
  id?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

export type AuthenticateResponse = {
  __typename?: 'AuthenticateResponse';
  authToken?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  sessionResponse?: Maybe<SessionResponse>;
};

export type Barrel = {
  __typename?: 'Barrel';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  urlPath?: Maybe<Scalars['String']>;
};

/** Represents a shopping cart with items, pricing, and checkout information. */
export type Cart = {
  __typename?: 'Cart';
  appliedCartRuleNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingAddress?: Maybe<CartAddress>;
  cartId?: Maybe<Scalars['String']>;
  cartRules?: Maybe<Array<Maybe<CartRule>>>;
  couponCode?: Maybe<Scalars['String']>;
  couponDiscountAmount?: Maybe<Scalars['Int']>;
  customerNote?: Maybe<Scalars['String']>;
  /** @deprecated Use flexVouchers instead */
  flexVoucherAmount?: Maybe<Scalars['Int']>;
  /** @deprecated Use flexVouchers instead */
  flexVoucherCode?: Maybe<Scalars['String']>;
  flexVoucherUsedAmount?: Maybe<Scalars['Int']>;
  flexVouchers?: Maybe<Array<Maybe<FlexVoucher>>>;
  fulfilledRestrictions?: Maybe<Array<Maybe<CartRestriction>>>;
  groupVoucherCode?: Maybe<Scalars['String']>;
  groupVoucherNewsletter?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isEnPrimeur?: Maybe<Scalars['Boolean']>;
  isVirtual?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<CartItem>>>;
  itemsTotalBulkDiscount?: Maybe<Scalars['Int']>;
  itemsTotalPrice?: Maybe<Scalars['Int']>;
  itemsTotalQty?: Maybe<Scalars['Int']>;
  newsletter?: Maybe<Scalars['Boolean']>;
  preorderDate?: Maybe<Scalars['String']>;
  requiredRestrictions?: Maybe<Array<Maybe<CartRestriction>>>;
  sameAsBilling?: Maybe<Scalars['Boolean']>;
  shippingAddress?: Maybe<CartAddress>;
  shippingMethod?: Maybe<ShippingMethod>;
  /** A key-value array of test cases, used for A/B testing */
  testCases?: Maybe<Scalars['String']>;
  totalDiscount?: Maybe<Scalars['Int']>;
  totalPrice?: Maybe<Scalars['Int']>;
  totalPriceBeforeAllDiscount?: Maybe<Scalars['Int']>;
  totalTax?: Maybe<Scalars['Int']>;
  totalToPayPrice?: Maybe<Scalars['Int']>;
  userVerifications?: Maybe<Array<Maybe<CartRestriction>>>;
};

export type CartAddress = {
  __typename?: 'CartAddress';
  address?: Maybe<Scalars['String']>;
  addressCity?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['Int']>;
  customerType?: Maybe<Scalars['String']>;
  cvr?: Maybe<Scalars['String']>;
  ean?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  groupVoucherCollectiveDelivery?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceCustomerPrefill?: Maybe<Scalars['Boolean']>;
  lockAddress?: Maybe<Scalars['Boolean']>;
  lockAddressCity?: Maybe<Scalars['Boolean']>;
  lockAddressZip?: Maybe<Scalars['Boolean']>;
  lockCompany?: Maybe<Scalars['Boolean']>;
  lockCountry?: Maybe<Scalars['Boolean']>;
  lockCvr?: Maybe<Scalars['Boolean']>;
  lockEan?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  showEAN?: Maybe<Scalars['Boolean']>;
};

/** Represents an item in the shopping cart with product details and quantity. */
export type CartItem = {
  __typename?: 'CartItem';
  appliedCartRuleNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  attributeSet?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  ctaText?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['Int']>;
  discountPercent?: Maybe<Scalars['Int']>;
  fulfilledRestrictions?: Maybe<Array<Maybe<CartRestriction>>>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Image>;
  isEnPrimeur?: Maybe<Scalars['Boolean']>;
  isFree?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  preorderDate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  priceBeforeDiscount?: Maybe<Scalars['Int']>;
  productSubType?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  qtyPrice?: Maybe<Scalars['Int']>;
  qtyPriceBeforeDiscount?: Maybe<Scalars['Int']>;
  requiredRestrictions?: Maybe<Array<Maybe<CartRestriction>>>;
  salableQty?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  stockStatus?: Maybe<CartItemStockStatus>;
  title?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  vismaId?: Maybe<Scalars['ID']>;
};

export enum CartItemStockStatus {
  InStock = 'IN_STOCK',
  NotEnoughStock = 'NOT_ENOUGH_STOCK',
  OutOfStock = 'OUT_OF_STOCK'
}

export enum CartRestriction {
  Min_15Years = 'MIN_15_YEARS',
  Min_16Years = 'MIN_16_YEARS',
  Min_17Years = 'MIN_17_YEARS',
  Min_18Years = 'MIN_18_YEARS',
  Min_19Years = 'MIN_19_YEARS',
  Min_20Years = 'MIN_20_YEARS',
  Min_21Years = 'MIN_21_YEARS',
  Min_22Years = 'MIN_22_YEARS',
  Min_23Years = 'MIN_23_YEARS',
  Min_24Years = 'MIN_24_YEARS',
  Min_25Years = 'MIN_25_YEARS'
}

export type CartRule = {
  __typename?: 'CartRule';
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Classics = TaxonomyBase & {
  __typename?: 'Classics';
  /** @deprecated Not used in practice */
  attributeValueCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['ID']>;
  path?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  vismaReference?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
};

export type CompanyProfile = {
  __typename?: 'CompanyProfile';
  contactProfile?: Maybe<ContactProfile>;
  groupVoucherCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
};

export type ContactProfile = {
  __typename?: 'ContactProfile';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Context = {
  __typename?: 'Context';
  data?: Maybe<ContextType>;
  key?: Maybe<Scalars['String']>;
};

export type ContextType = GroupVoucherCode;

export type Country = {
  __typename?: 'Country';
  contentImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  urlPath?: Maybe<Scalars['String']>;
};

export type CreateTestPaymentResult = {
  __typename?: 'CreateTestPaymentResult';
  amount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  paymentId?: Maybe<Scalars['String']>;
  paymentLink?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum CustomerAccountType {
  Company = 'COMPANY',
  Private = 'PRIVATE'
}

export enum CustomerAccountV2Type {
  Company = 'COMPANY',
  Private = 'PRIVATE'
}

export type CustomerAddressInput = {
  city: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  customerCountryNumber?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  telephone: Scalars['String'];
  vat?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type CustomerAddressV2Input = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  customerCountryNumber?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  vat?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type CustomerProfile = {
  __typename?: 'CustomerProfile';
  accountType: Scalars['ID'];
  addresses?: Maybe<Array<Maybe<CustomerProfileAddress>>>;
  ageVerificationId?: Maybe<Scalars['String']>;
  ageVerificationStatus?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  creditAmount?: Maybe<Scalars['Int']>;
  creditBalance?: Maybe<Scalars['Int']>;
  creditConditions?: Maybe<Scalars['String']>;
  cvr?: Maybe<Scalars['String']>;
  defaultBillingAddress?: Maybe<CustomerProfileAddress>;
  deliveryComment?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  ean?: Maybe<Scalars['String']>;
  emailForOrderConfirmation: Scalars['String'];
  fullName: Scalars['String'];
  groupVoucherCode?: Maybe<Scalars['String']>;
  hasPassword: Scalars['Boolean'];
  hubspotContact?: Maybe<HubspotContact>;
  id: Scalars['ID'];
  invoiceCustomerVismaid?: Maybe<Scalars['String']>;
  invoiceEmail?: Maybe<Scalars['String']>;
  isEmailConfirmed: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  limitedToGroupVoucher?: Maybe<Scalars['Boolean']>;
  onlyAllowInvoicePayment?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  reviews?: Maybe<Array<Maybe<CustomerReview>>>;
  superpayUUID?: Maybe<Scalars['String']>;
  vismaId?: Maybe<Scalars['ID']>;
  websiteCode?: Maybe<Scalars['String']>;
  wishlist?: Maybe<Array<Maybe<WineProduct>>>;
};

export type CustomerProfileAddress = {
  __typename?: 'CustomerProfileAddress';
  address?: Maybe<Scalars['String']>;
  addressCity?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  /** @deprecated Moved to CustomerProfile */
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['Int']>;
  /** @deprecated Moved to CustomerProfile */
  cvr?: Maybe<Scalars['String']>;
  /** @deprecated Moved to CustomerProfile */
  ean?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Moved to CustomerProfile as phoneNumber */
  phone?: Maybe<Scalars['String']>;
};

export type CustomerReview = {
  __typename?: 'CustomerReview';
  product?: Maybe<WineProduct>;
  rating: Scalars['Int'];
};

export type CustomerUpsertInput = {
  accountType: CustomerAccountType;
  billingAddress?: InputMaybe<CustomerAddressInput>;
  creditAmount?: InputMaybe<Scalars['Int']>;
  creditBalance?: InputMaybe<Scalars['Int']>;
  creditConditions?: InputMaybe<Scalars['String']>;
  customerLanguageNumber?: InputMaybe<Scalars['String']>;
  deliveryComment?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  groupVoucherCode?: InputMaybe<Scalars['String']>;
  invoiceCustomerVismaid?: InputMaybe<Scalars['String']>;
  invoiceEmail?: InputMaybe<Scalars['String']>;
  limitedToGroupVoucher?: InputMaybe<Scalars['Boolean']>;
  onlyAllowInvoicePayment?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<CustomerAddressInput>;
  websiteCode?: InputMaybe<Scalars['String']>;
};

export type CustomerUpsertV2Input = {
  accountType: CustomerAccountV2Type;
  billingAddress?: InputMaybe<CustomerAddressV2Input>;
  companyName?: InputMaybe<Scalars['String']>;
  creditAmount?: InputMaybe<Scalars['Int']>;
  creditBalance?: InputMaybe<Scalars['Int']>;
  creditConditions?: InputMaybe<Scalars['String']>;
  customerLanguageNumber?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deliveryComment?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
  groupVoucherCode?: InputMaybe<Scalars['String']>;
  invoiceCustomerVismaid?: InputMaybe<Scalars['String']>;
  invoiceEmail?: InputMaybe<Scalars['String']>;
  limitedToGroupVoucher?: InputMaybe<Scalars['Boolean']>;
  onlyAllowInvoicePayment?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<CustomerAddressV2Input>;
  websiteCode?: InputMaybe<Scalars['String']>;
};

export type DeleteBadgeMutationResult = {
  __typename?: 'DeleteBadgeMutationResult';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteStoryblokCacheResponse = {
  __typename?: 'DeleteStoryblokCacheResponse';
  failedCount: Scalars['Int'];
  results?: Maybe<Array<Maybe<StoryblokCacheDeleteResult>>>;
  success: Scalars['Boolean'];
  successCount: Scalars['Int'];
  totalProcessed: Scalars['Int'];
};

export type DeliveryMethodInfo = {
  __typename?: 'DeliveryMethodInfo';
  method?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Int']>;
  /** @deprecated Use 'amount' instead */
  amountExVat?: Maybe<Scalars['Int']>;
  amountIncVat?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  to?: Maybe<Scalars['DateTime']>;
};

export type District = {
  __typename?: 'District';
  contentImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  urlPath?: Maybe<Scalars['String']>;
};

export type FakeAddressInfo = {
  __typename?: 'FakeAddressInfo';
  city?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  street?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FlexVoucher = {
  __typename?: 'FlexVoucher';
  balance?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  withdrawnBalance?: Maybe<Scalars['Int']>;
};

export type Food = {
  __typename?: 'Food';
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Use `icon` from magento instead. This was used to get icon from storyblok */
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  pdfIcon?: Maybe<Scalars['String']>;
};

export type FormSubmitMessage = {
  __typename?: 'FormSubmitMessage';
  message: Scalars['String'];
  type: Scalars['String'];
};

export type GetAllCartAddress = {
  __typename?: 'GetAllCartAddress';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<CartAddress>>>;
  total: Scalars['Int'];
};

export type GetAllCartRule = {
  __typename?: 'GetAllCartRule';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<CartRule>>>;
  total: Scalars['Int'];
};

export type GetAllClassics = {
  __typename?: 'GetAllClassics';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<Classics>>>;
  total: Scalars['Int'];
};

export type GetAllCustomerProfile = {
  __typename?: 'GetAllCustomerProfile';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<CustomerProfile>>>;
  total: Scalars['Int'];
};

export type GetAllCustomerProfileAddress = {
  __typename?: 'GetAllCustomerProfileAddress';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<CustomerProfileAddress>>>;
  total: Scalars['Int'];
};

export type GetAllDiscount = {
  __typename?: 'GetAllDiscount';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<Discount>>>;
  total: Scalars['Int'];
};

export type GetAllGroupVoucherCode = {
  __typename?: 'GetAllGroupVoucherCode';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<GroupVoucherCode>>>;
  total: Scalars['Int'];
};

export type GetAllPriceTablePricing = {
  __typename?: 'GetAllPriceTablePricing';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<PriceTablePricing>>>;
  total: Scalars['Int'];
};

export type GetAllRating = {
  __typename?: 'GetAllRating';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<Rating>>>;
  total: Scalars['Int'];
};

export type GetAllRatingSymbols = {
  __typename?: 'GetAllRatingSymbols';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<RatingSymbols>>>;
  total: Scalars['Int'];
};

export type GetAllReviewer = {
  __typename?: 'GetAllReviewer';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<Reviewer>>>;
  total: Scalars['Int'];
};

export type GetAllUnit = {
  __typename?: 'GetAllUnit';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<Unit>>>;
  total: Scalars['Int'];
};

export type GetAllUrlRedirect = {
  __typename?: 'GetAllUrlRedirect';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<UrlRedirect>>>;
  total: Scalars['Int'];
};

export type GetAllWineProduct = {
  __typename?: 'GetAllWineProduct';
  filtered: Scalars['Int'];
  rows?: Maybe<Array<Maybe<WineProduct>>>;
  total: Scalars['Int'];
};

export type Grape = {
  __typename?: 'Grape';
  contentImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  urlPath?: Maybe<Scalars['String']>;
};

export type GroupVoucherCode = {
  __typename?: 'GroupVoucherCode';
  code: Scalars['String'];
  companyProfile?: Maybe<CompanyProfile>;
  /** Values: 1 or 0 */
  delivery: Scalars['Int'];
  /** Only used if 'delivery' is equal to 1 */
  deliveryAddress?: Maybe<Scalars['String']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryCity?: Maybe<Scalars['String']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryCompanyName?: Maybe<Scalars['String']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryCountry?: Maybe<Scalars['String']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryDate?: Maybe<Scalars['Date']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryEan?: Maybe<Scalars['String']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryName?: Maybe<Scalars['String']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryStreetFloor?: Maybe<Scalars['String']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryStreetName?: Maybe<Scalars['String']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryStreetNumber?: Maybe<Scalars['String']>;
  /** Only used if 'delivery' is equal to 1 */
  deliveryZip?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  freeShipping: Scalars['Boolean'];
  prices?: Maybe<Array<Maybe<GroupVoucherCodePrice>>>;
  published: Scalars['Boolean'];
  redirectTo?: Maybe<Scalars['String']>;
  showSuggestedRetailPrice?: Maybe<Scalars['Boolean']>;
  showVatText?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['Date']>;
  urlKey?: Maybe<Scalars['String']>;
  vismaCampaignId: Scalars['String'];
};

export type GroupVoucherCodeInput = {
  code: Scalars['String'];
  deliveryAddress?: InputMaybe<VoucherAddress>;
  endDate: Scalars['Date'];
  freeShipping: Scalars['Boolean'];
  products: Array<InputMaybe<VoucherProduct>>;
  published: Scalars['Boolean'];
  redirectTo?: InputMaybe<Scalars['String']>;
  showSuggestedRetailPrice?: InputMaybe<Scalars['Boolean']>;
  showVatText?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['Date'];
  title: Scalars['String'];
  useDeliveryAddress: Scalars['Boolean'];
  vismaCampaignId: Scalars['String'];
};

export type GroupVoucherCodePrice = {
  __typename?: 'GroupVoucherCodePrice';
  id?: Maybe<Scalars['ID']>;
  price: Scalars['String'];
  productId: Scalars['ID'];
  vismaId: Scalars['String'];
};

export type Head = {
  __typename?: 'Head';
  id?: Maybe<Scalars['ID']>;
  link?: Maybe<Array<Maybe<HeadLink>>>;
  meta?: Maybe<Array<Maybe<HeadMeta>>>;
  path?: Maybe<Scalars['String']>;
  structuredDataScheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type HeadLink = {
  __typename?: 'HeadLink';
  charset?: Maybe<Scalars['String']>;
  crossorigin?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  hreflang?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['String']>;
  rel?: Maybe<Scalars['String']>;
  rev?: Maybe<Scalars['String']>;
  sizes?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type HeadMeta = {
  __typename?: 'HeadMeta';
  charset?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  httpEquiv?: Maybe<Scalars['String']>;
  itemprop?: Maybe<Scalars['String']>;
  meta_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type HubspotContact = {
  __typename?: 'HubspotContact';
  email: Scalars['String'];
  id: Scalars['ID'];
  isSubscribedToOneToTwoEmailsAWeek: Scalars['Boolean'];
  isSubscribedToSupervinNewsletter: Scalars['Boolean'];
  supervinNewsletter: Scalars['Boolean'];
};

export type Image = {
  __typename?: 'Image';
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  large?: Maybe<Scalars['String']>;
  original?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  small?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type InputCreateAttribute = {
  code: Scalars['String'];
  value?: InputMaybe<Scalars['scalar']>;
};

export type InputCreateCartAddress = {
  address?: InputMaybe<Scalars['String']>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['Int']>;
  customerType?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fullname?: InputMaybe<Scalars['String']>;
  groupVoucherCollectiveDelivery?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type InputCreateCartRule = {
  amount?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type InputCreateClassics = {
  attributeValueCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  machineName?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  seoDescription?: InputMaybe<Scalars['String']>;
  seoTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  vismaReference?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
};

export type InputCreateCompanyProfile = {
  contactProfile?: InputMaybe<InputCreateContactProfile>;
  groupVoucherCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
};

export type InputCreateContactProfile = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type InputCreateCustomerProfile = {
  accountType: Scalars['ID'];
  addresses?: InputMaybe<Array<InputMaybe<InputCreateCustomerProfileAddress>>>;
  ageVerificationId?: InputMaybe<Scalars['String']>;
  ageVerificationStatus?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  creditAmount?: InputMaybe<Scalars['Int']>;
  creditBalance?: InputMaybe<Scalars['Int']>;
  creditConditions?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  defaultBillingAddress?: InputMaybe<InputCreateCustomerProfileAddress>;
  deliveryComment?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  emailForOrderConfirmation: Scalars['String'];
  fullName: Scalars['String'];
  groupVoucherCode?: InputMaybe<Scalars['String']>;
  hasPassword: Scalars['Boolean'];
  hubspotContact?: InputMaybe<InputCreateHubspotContact>;
  invoiceCustomerVismaid?: InputMaybe<Scalars['String']>;
  invoiceEmail?: InputMaybe<Scalars['String']>;
  isEmailConfirmed: Scalars['Boolean'];
  language?: InputMaybe<Scalars['String']>;
  limitedToGroupVoucher?: InputMaybe<Scalars['Boolean']>;
  onlyAllowInvoicePayment?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  reviews?: InputMaybe<Array<InputMaybe<InputCreateCustomerReview>>>;
  superpayUUID?: InputMaybe<Scalars['String']>;
  vismaId?: InputMaybe<Scalars['ID']>;
  websiteCode?: InputMaybe<Scalars['String']>;
  wishlist?: InputMaybe<Array<InputMaybe<InputCreateWineProduct>>>;
};

export type InputCreateCustomerProfileAddress = {
  address?: InputMaybe<Scalars['String']>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['Int']>;
  cvr?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  fullname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type InputCreateCustomerReview = {
  product?: InputMaybe<InputCreateWineProduct>;
  rating: Scalars['Int'];
};

export type InputCreateDiscount = {
  amount?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type InputCreateFood = {
  icon?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  pdfIcon?: InputMaybe<Scalars['String']>;
};

export type InputCreateGrape = {
  contentImage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};

export type InputCreateGroupVoucherCode = {
  code: Scalars['String'];
  companyProfile?: InputMaybe<InputCreateCompanyProfile>;
  delivery: Scalars['Int'];
  deliveryAddress?: InputMaybe<Scalars['String']>;
  deliveryCity?: InputMaybe<Scalars['String']>;
  deliveryCompanyName?: InputMaybe<Scalars['String']>;
  deliveryCountry?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  deliveryEan?: InputMaybe<Scalars['String']>;
  deliveryName?: InputMaybe<Scalars['String']>;
  deliveryStreetFloor?: InputMaybe<Scalars['String']>;
  deliveryStreetName?: InputMaybe<Scalars['String']>;
  deliveryStreetNumber?: InputMaybe<Scalars['String']>;
  deliveryZip?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  freeShipping: Scalars['Boolean'];
  prices?: InputMaybe<Array<InputMaybe<InputCreateGroupVoucherCodePrice>>>;
  published: Scalars['Boolean'];
  redirectTo?: InputMaybe<Scalars['String']>;
  showSuggestedRetailPrice?: InputMaybe<Scalars['Boolean']>;
  showVatText?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  urlKey?: InputMaybe<Scalars['String']>;
  vismaCampaignId: Scalars['String'];
};

export type InputCreateGroupVoucherCodePrice = {
  price: Scalars['String'];
  productId: Scalars['ID'];
  vismaId: Scalars['String'];
};

export type InputCreateHubspotContact = {
  email: Scalars['String'];
  id: Scalars['ID'];
  isSubscribedToOneToTwoEmailsAWeek: Scalars['Boolean'];
  isSubscribedToSupervinNewsletter: Scalars['Boolean'];
  supervinNewsletter: Scalars['Boolean'];
};

export type InputCreateImage = {
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  large?: InputMaybe<Scalars['String']>;
  original?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  small?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type InputCreatePriceTable = {
  defaultQuantity?: InputMaybe<Scalars['String']>;
  pricings?: InputMaybe<Array<InputMaybe<InputCreatePriceTablePricing>>>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type InputCreatePriceTablePricing = {
  amount: Scalars['Int'];
  discount?: InputMaybe<InputCreateDiscount>;
  minQty?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  websiteCode?: InputMaybe<Scalars['String']>;
};

export type InputCreateProductAuthor = {
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
};

export type InputCreateProductImageBadge = {
  badgeColor?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type InputCreateRating = {
  hideReview?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isPreviousVintage?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  maxRatingSymbols?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  rating?: InputMaybe<Scalars['Int']>;
  ratingPoint?: InputMaybe<Scalars['String']>;
  ratingSortWeight?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Scalars['String']>;
  reviewSnippet?: InputMaybe<Scalars['String']>;
  reviewer?: InputMaybe<InputCreateReviewer>;
  starCount?: InputMaybe<Scalars['Int']>;
  symbol?: InputMaybe<InputCreateRatingSymbols>;
};

export type InputCreateRatingSymbols = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  machineName?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  seoDescription?: InputMaybe<Scalars['String']>;
  seoTitle?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  vismaReference?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
};

export type InputCreateReviewer = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isVisibleOnline?: InputMaybe<Scalars['Boolean']>;
  machineName?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  ratingType?: InputMaybe<Scalars['String']>;
  seoDescription?: InputMaybe<Scalars['String']>;
  seoTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  vismaReference?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
};

export type InputCreateTopCta = {
  icon?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type InputCreateUnit = {
  id?: InputMaybe<Scalars['String']>;
  machineName?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type InputCreateUrlRedirect = {
  redirect?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type InputCreateWineMeta = {
  acidContent?: InputMaybe<Scalars['Int']>;
  alcohol?: InputMaybe<Scalars['String']>;
  allergens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  area?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Array<InputMaybe<InputCreateAttribute>>>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classics?: InputMaybe<Array<InputMaybe<InputCreateClassics>>>;
  contentLabel?: InputMaybe<Scalars['String']>;
  contents?: InputMaybe<Scalars['String']>;
  contentsCl?: InputMaybe<Scalars['Int']>;
  countryName?: InputMaybe<Scalars['String']>;
  districtName?: InputMaybe<Scalars['String']>;
  energyLabel?: InputMaybe<Scalars['String']>;
  energyLabelDoc?: InputMaybe<Scalars['String']>;
  foods?: InputMaybe<Array<InputMaybe<InputCreateFood>>>;
  grapes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  grapesV2?: InputMaybe<Array<InputMaybe<InputCreateGrape>>>;
  measurementUnit?: InputMaybe<Scalars['String']>;
  nutritionalInfoUrl?: InputMaybe<Scalars['String']>;
  portType?: InputMaybe<Scalars['String']>;
  powerLabel?: InputMaybe<Scalars['String']>;
  powerValue?: InputMaybe<Scalars['Int']>;
  producerName?: InputMaybe<Scalars['String']>;
  productDataSheet?: InputMaybe<Scalars['String']>;
  productSubType?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  ratings?: InputMaybe<Array<InputMaybe<InputCreateRating>>>;
  residualSugar?: InputMaybe<Scalars['Int']>;
  savingPotential?: InputMaybe<Scalars['String']>;
  serving?: InputMaybe<Scalars['String']>;
  subDistrictName?: InputMaybe<Scalars['String']>;
  sweetnessLabel?: InputMaybe<Scalars['String']>;
  sweetnessValue?: InputMaybe<Scalars['Int']>;
  unit?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<InputCreateUnit>;
  vintage?: InputMaybe<Scalars['Int']>;
  wineBodyLabel?: InputMaybe<Scalars['String']>;
  wineBodyValue?: InputMaybe<Scalars['Int']>;
  wineType?: InputMaybe<Scalars['String']>;
};

export type InputCreateWineProduct = {
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  baPercentage?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  canBeAddedToCart?: InputMaybe<Scalars['Boolean']>;
  closure?: InputMaybe<Scalars['String']>;
  costPrice?: InputMaybe<Scalars['Int']>;
  ctaHidePrice?: InputMaybe<Scalars['Boolean']>;
  ctaLink?: InputMaybe<Scalars['String']>;
  ctaStockText?: InputMaybe<Scalars['String']>;
  ctaTitle?: InputMaybe<Scalars['String']>;
  defaultQuantity?: InputMaybe<Scalars['Int']>;
  has360BottleImage?: InputMaybe<Scalars['Boolean']>;
  has360BoxImage?: InputMaybe<Scalars['Boolean']>;
  hideDiscountCountdown?: InputMaybe<Scalars['Boolean']>;
  hidePriceTable?: InputMaybe<Scalars['Boolean']>;
  hideReview?: InputMaybe<Scalars['Boolean']>;
  hideShippingCountdown?: InputMaybe<Scalars['Boolean']>;
  hideSupervinAdvantages?: InputMaybe<Scalars['Boolean']>;
  highlightExpireDate?: InputMaybe<Scalars['String']>;
  highlightText?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<InputCreateImage>;
  images?: InputMaybe<Array<InputMaybe<InputCreateImage>>>;
  isB2b?: InputMaybe<Scalars['Boolean']>;
  isBundleProduct?: InputMaybe<Scalars['Boolean']>;
  isEnPrimeur?: InputMaybe<Scalars['Boolean']>;
  isLeftover?: InputMaybe<Scalars['Boolean']>;
  isSecret?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<InputCreateWineMeta>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaTitle?: InputMaybe<Scalars['String']>;
  minimumQuantity?: InputMaybe<Scalars['String']>;
  nodePath?: InputMaybe<Scalars['String']>;
  nonAlcoholic?: InputMaybe<Scalars['Boolean']>;
  organic?: InputMaybe<Scalars['Boolean']>;
  packaging?: InputMaybe<Scalars['String']>;
  pageWhitelist?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdfText?: InputMaybe<Scalars['String']>;
  preorderDate?: InputMaybe<Scalars['String']>;
  priceTable: InputCreatePriceTable;
  producerDescription?: InputMaybe<Scalars['String']>;
  productAuthor?: InputMaybe<InputCreateProductAuthor>;
  productDescription?: InputMaybe<Scalars['String']>;
  productImageBadge?: InputMaybe<InputCreateProductImageBadge>;
  productionMethodDescription?: InputMaybe<Scalars['String']>;
  promoteFrontPage?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedWebsites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchSortWeight?: InputMaybe<Scalars['String']>;
  searchWords?: InputMaybe<Scalars['String']>;
  secretKey?: InputMaybe<Scalars['String']>;
  showHighlight?: InputMaybe<Scalars['Boolean']>;
  sku: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['Int']>;
  supplierName?: InputMaybe<Scalars['String']>;
  supplierPhoneNumber?: InputMaybe<Scalars['String']>;
  tastingNotesDescription?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  topCta?: InputMaybe<InputCreateTopCta>;
  typeId?: InputMaybe<ProductType>;
  urlRedirects?: InputMaybe<Array<InputMaybe<InputCreateUrlRedirect>>>;
  videoLink?: InputMaybe<Scalars['String']>;
  vimeoId?: InputMaybe<Scalars['String']>;
  vismaProductNumber: Scalars['String'];
  vismaSku?: InputMaybe<Scalars['String']>;
  youTubeId?: InputMaybe<Scalars['String']>;
};

export type InputUpdateAttribute = {
  code?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['scalar']>;
};

export type InputUpdateCart = {
  appliedCartRuleNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingAddress?: InputMaybe<InputUpdateCartAddress>;
  cartId?: InputMaybe<Scalars['String']>;
  cartRules?: InputMaybe<Array<InputMaybe<InputUpdateCartRule>>>;
  couponCode?: InputMaybe<Scalars['String']>;
  couponDiscountAmount?: InputMaybe<Scalars['Int']>;
  customerNote?: InputMaybe<Scalars['String']>;
  flexVoucherAmount?: InputMaybe<Scalars['Int']>;
  flexVoucherCode?: InputMaybe<Scalars['String']>;
  flexVoucherUsedAmount?: InputMaybe<Scalars['Int']>;
  flexVouchers?: InputMaybe<Array<InputMaybe<InputUpdateFlexVoucher>>>;
  fulfilledRestrictions?: InputMaybe<Array<InputMaybe<CartRestriction>>>;
  groupVoucherCode?: InputMaybe<Scalars['String']>;
  groupVoucherNewsletter?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isEnPrimeur?: InputMaybe<Scalars['Boolean']>;
  isVirtual?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<InputUpdateCartItem>>>;
  itemsTotalBulkDiscount?: InputMaybe<Scalars['Int']>;
  itemsTotalPrice?: InputMaybe<Scalars['Int']>;
  itemsTotalQty?: InputMaybe<Scalars['Int']>;
  newsletter?: InputMaybe<Scalars['Boolean']>;
  preorderDate?: InputMaybe<Scalars['String']>;
  requiredRestrictions?: InputMaybe<Array<InputMaybe<CartRestriction>>>;
  sameAsBilling?: InputMaybe<Scalars['Boolean']>;
  shippingAddress?: InputMaybe<InputUpdateCartAddress>;
  shippingMethod?: InputMaybe<InputUpdateShippingMethod>;
  testCases?: InputMaybe<Scalars['String']>;
  totalDiscount?: InputMaybe<Scalars['Int']>;
  totalPrice?: InputMaybe<Scalars['Int']>;
  totalPriceBeforeAllDiscount?: InputMaybe<Scalars['Int']>;
  totalTax?: InputMaybe<Scalars['Int']>;
  totalToPayPrice?: InputMaybe<Scalars['Int']>;
  userVerifications?: InputMaybe<Array<InputMaybe<CartRestriction>>>;
};

export type InputUpdateCartAddress = {
  address?: InputMaybe<Scalars['String']>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['Int']>;
  customerType?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fullname?: InputMaybe<Scalars['String']>;
  groupVoucherCollectiveDelivery?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type InputUpdateCartItem = {
  appliedCartRuleNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  attributeSet?: InputMaybe<Scalars['String']>;
  compareAtPrice?: InputMaybe<Scalars['Int']>;
  ctaText?: InputMaybe<Scalars['String']>;
  discountAmount?: InputMaybe<Scalars['Int']>;
  discountPercent?: InputMaybe<Scalars['Int']>;
  fulfilledRestrictions?: InputMaybe<Array<InputMaybe<CartRestriction>>>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<InputUpdateImage>;
  isEnPrimeur?: InputMaybe<Scalars['Boolean']>;
  isFree?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  preorderDate?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  priceBeforeDiscount?: InputMaybe<Scalars['Int']>;
  productSubType?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  qtyPrice?: InputMaybe<Scalars['Int']>;
  qtyPriceBeforeDiscount?: InputMaybe<Scalars['Int']>;
  requiredRestrictions?: InputMaybe<Array<InputMaybe<CartRestriction>>>;
  salableQty?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
  stockStatus?: InputMaybe<CartItemStockStatus>;
  title?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  vismaId?: InputMaybe<Scalars['ID']>;
};

export type InputUpdateCartRule = {
  amount?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type InputUpdateClassics = {
  attributeValueCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  machineName?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  seoDescription?: InputMaybe<Scalars['String']>;
  seoTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  vismaReference?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
};

export type InputUpdateCompanyProfile = {
  contactProfile?: InputMaybe<InputUpdateContactProfile>;
  groupVoucherCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
};

export type InputUpdateContactProfile = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type InputUpdateCustomerProfile = {
  accountType?: InputMaybe<Scalars['ID']>;
  addresses?: InputMaybe<Array<InputMaybe<InputUpdateCustomerProfileAddress>>>;
  ageVerificationId?: InputMaybe<Scalars['String']>;
  ageVerificationStatus?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  creditAmount?: InputMaybe<Scalars['Int']>;
  creditBalance?: InputMaybe<Scalars['Int']>;
  creditConditions?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  defaultBillingAddress?: InputMaybe<InputUpdateCustomerProfileAddress>;
  deliveryComment?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  emailForOrderConfirmation?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  groupVoucherCode?: InputMaybe<Scalars['String']>;
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  hubspotContact?: InputMaybe<InputUpdateHubspotContact>;
  invoiceCustomerVismaid?: InputMaybe<Scalars['String']>;
  invoiceEmail?: InputMaybe<Scalars['String']>;
  isEmailConfirmed?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  limitedToGroupVoucher?: InputMaybe<Scalars['Boolean']>;
  onlyAllowInvoicePayment?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  reviews?: InputMaybe<Array<InputMaybe<InputUpdateCustomerReview>>>;
  superpayUUID?: InputMaybe<Scalars['String']>;
  vismaId?: InputMaybe<Scalars['ID']>;
  websiteCode?: InputMaybe<Scalars['String']>;
  wishlist?: InputMaybe<Array<InputMaybe<InputUpdateWineProduct>>>;
};

export type InputUpdateCustomerProfileAddress = {
  address?: InputMaybe<Scalars['String']>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['Int']>;
  cvr?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  fullname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type InputUpdateCustomerReview = {
  product?: InputMaybe<InputUpdateWineProduct>;
  rating?: InputMaybe<Scalars['Int']>;
};

export type InputUpdateDiscount = {
  amount?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type InputUpdateFlexVoucher = {
  balance?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  withdrawnBalance?: InputMaybe<Scalars['Int']>;
};

export type InputUpdateGrape = {
  contentImage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};

export type InputUpdateGroupVoucherCode = {
  code?: InputMaybe<Scalars['String']>;
  companyProfile?: InputMaybe<InputUpdateCompanyProfile>;
  delivery?: InputMaybe<Scalars['Int']>;
  deliveryAddress?: InputMaybe<Scalars['String']>;
  deliveryCity?: InputMaybe<Scalars['String']>;
  deliveryCompanyName?: InputMaybe<Scalars['String']>;
  deliveryCountry?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  deliveryEan?: InputMaybe<Scalars['String']>;
  deliveryName?: InputMaybe<Scalars['String']>;
  deliveryStreetFloor?: InputMaybe<Scalars['String']>;
  deliveryStreetName?: InputMaybe<Scalars['String']>;
  deliveryStreetNumber?: InputMaybe<Scalars['String']>;
  deliveryZip?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  freeShipping?: InputMaybe<Scalars['Boolean']>;
  prices?: InputMaybe<Array<InputMaybe<InputUpdateGroupVoucherCodePrice>>>;
  published?: InputMaybe<Scalars['Boolean']>;
  redirectTo?: InputMaybe<Scalars['String']>;
  showSuggestedRetailPrice?: InputMaybe<Scalars['Boolean']>;
  showVatText?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  urlKey?: InputMaybe<Scalars['String']>;
  vismaCampaignId?: InputMaybe<Scalars['String']>;
};

export type InputUpdateGroupVoucherCodePrice = {
  price?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  vismaId?: InputMaybe<Scalars['String']>;
};

export type InputUpdateHubspotContact = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isSubscribedToOneToTwoEmailsAWeek?: InputMaybe<Scalars['Boolean']>;
  isSubscribedToSupervinNewsletter?: InputMaybe<Scalars['Boolean']>;
  supervinNewsletter?: InputMaybe<Scalars['Boolean']>;
};

export type InputUpdateImage = {
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  large?: InputMaybe<Scalars['String']>;
  original?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  small?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type InputUpdatePriceTable = {
  defaultQuantity?: InputMaybe<Scalars['String']>;
  pricings?: InputMaybe<Array<InputMaybe<InputUpdatePriceTablePricing>>>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type InputUpdatePriceTablePricing = {
  amount?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<InputUpdateDiscount>;
  minQty?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  websiteCode?: InputMaybe<Scalars['String']>;
};

export type InputUpdateProductAuthor = {
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
};

export type InputUpdateProductImageBadge = {
  badgeColor?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type InputUpdateRating = {
  hideReview?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isPreviousVintage?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  maxRatingSymbols?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  rating?: InputMaybe<Scalars['Int']>;
  ratingPoint?: InputMaybe<Scalars['String']>;
  ratingSortWeight?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Scalars['String']>;
  reviewSnippet?: InputMaybe<Scalars['String']>;
  reviewer?: InputMaybe<Scalars['ID']>;
  starCount?: InputMaybe<Scalars['Int']>;
  symbol?: InputMaybe<Scalars['ID']>;
};

export type InputUpdateRatingSymbols = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  machineName?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  seoDescription?: InputMaybe<Scalars['String']>;
  seoTitle?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  vismaReference?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
};

export type InputUpdateReviewer = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isVisibleOnline?: InputMaybe<Scalars['Boolean']>;
  machineName?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  ratingType?: InputMaybe<Scalars['String']>;
  seoDescription?: InputMaybe<Scalars['String']>;
  seoTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  vismaReference?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
};

export type InputUpdateShippingMethod = {
  carrier?: InputMaybe<Scalars['String']>;
  carrier_logo?: InputMaybe<Scalars['String']>;
  carrier_title?: InputMaybe<Scalars['String']>;
  deliveryComment?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  dontDeliverDates?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  fastestDeliveryDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  label?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  priceDescription?: InputMaybe<Scalars['String']>;
  showCustomDatePicker?: InputMaybe<Scalars['Boolean']>;
  showWhereToLeavePackage?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type InputUpdateTopCta = {
  icon?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type InputUpdateUnit = {
  id?: InputMaybe<Scalars['String']>;
  machineName?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type InputUpdateUrlRedirect = {
  redirect?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type InputUpdateWineMeta = {
  acidContent?: InputMaybe<Scalars['Int']>;
  alcohol?: InputMaybe<Scalars['String']>;
  allergens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  area?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Array<InputMaybe<InputUpdateAttribute>>>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classics?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contentLabel?: InputMaybe<Scalars['String']>;
  contents?: InputMaybe<Scalars['String']>;
  contentsCl?: InputMaybe<Scalars['Int']>;
  countryName?: InputMaybe<Scalars['String']>;
  districtName?: InputMaybe<Scalars['String']>;
  energyLabel?: InputMaybe<Scalars['String']>;
  energyLabelDoc?: InputMaybe<Scalars['String']>;
  foods?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  grapes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  grapesV2?: InputMaybe<Array<InputMaybe<InputUpdateGrape>>>;
  measurementUnit?: InputMaybe<Scalars['String']>;
  nutritionalInfoUrl?: InputMaybe<Scalars['String']>;
  portType?: InputMaybe<Scalars['String']>;
  powerLabel?: InputMaybe<Scalars['String']>;
  powerValue?: InputMaybe<Scalars['Int']>;
  producerName?: InputMaybe<Scalars['String']>;
  productDataSheet?: InputMaybe<Scalars['String']>;
  productSubType?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  ratings?: InputMaybe<Array<InputMaybe<InputUpdateRating>>>;
  residualSugar?: InputMaybe<Scalars['Int']>;
  savingPotential?: InputMaybe<Scalars['String']>;
  serving?: InputMaybe<Scalars['String']>;
  subDistrictName?: InputMaybe<Scalars['String']>;
  sweetnessLabel?: InputMaybe<Scalars['String']>;
  sweetnessValue?: InputMaybe<Scalars['Int']>;
  unit?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<InputUpdateUnit>;
  vintage?: InputMaybe<Scalars['Int']>;
  wineBodyLabel?: InputMaybe<Scalars['String']>;
  wineBodyValue?: InputMaybe<Scalars['Int']>;
  wineType?: InputMaybe<Scalars['String']>;
};

export type InputUpdateWineProduct = {
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  baPercentage?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  canBeAddedToCart?: InputMaybe<Scalars['Boolean']>;
  closure?: InputMaybe<Scalars['String']>;
  costPrice?: InputMaybe<Scalars['Int']>;
  ctaHidePrice?: InputMaybe<Scalars['Boolean']>;
  ctaLink?: InputMaybe<Scalars['String']>;
  ctaStockText?: InputMaybe<Scalars['String']>;
  ctaTitle?: InputMaybe<Scalars['String']>;
  defaultQuantity?: InputMaybe<Scalars['Int']>;
  has360BottleImage?: InputMaybe<Scalars['Boolean']>;
  has360BoxImage?: InputMaybe<Scalars['Boolean']>;
  hideDiscountCountdown?: InputMaybe<Scalars['Boolean']>;
  hidePriceTable?: InputMaybe<Scalars['Boolean']>;
  hideReview?: InputMaybe<Scalars['Boolean']>;
  hideShippingCountdown?: InputMaybe<Scalars['Boolean']>;
  hideSupervinAdvantages?: InputMaybe<Scalars['Boolean']>;
  highlightExpireDate?: InputMaybe<Scalars['String']>;
  highlightText?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<InputUpdateImage>;
  images?: InputMaybe<Array<InputMaybe<InputUpdateImage>>>;
  isB2b?: InputMaybe<Scalars['Boolean']>;
  isBundleProduct?: InputMaybe<Scalars['Boolean']>;
  isEnPrimeur?: InputMaybe<Scalars['Boolean']>;
  isLeftover?: InputMaybe<Scalars['Boolean']>;
  isSecret?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<InputUpdateWineMeta>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaTitle?: InputMaybe<Scalars['String']>;
  minimumQuantity?: InputMaybe<Scalars['String']>;
  nodePath?: InputMaybe<Scalars['String']>;
  nonAlcoholic?: InputMaybe<Scalars['Boolean']>;
  organic?: InputMaybe<Scalars['Boolean']>;
  packaging?: InputMaybe<Scalars['String']>;
  pageWhitelist?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdfText?: InputMaybe<Scalars['String']>;
  preorderDate?: InputMaybe<Scalars['String']>;
  priceTable?: InputMaybe<InputUpdatePriceTable>;
  producerDescription?: InputMaybe<Scalars['String']>;
  productAuthor?: InputMaybe<InputUpdateProductAuthor>;
  productDescription?: InputMaybe<Scalars['String']>;
  productImageBadge?: InputMaybe<InputUpdateProductImageBadge>;
  productionMethodDescription?: InputMaybe<Scalars['String']>;
  promoteFrontPage?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedWebsites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchSortWeight?: InputMaybe<Scalars['String']>;
  searchWords?: InputMaybe<Scalars['String']>;
  secretKey?: InputMaybe<Scalars['String']>;
  showHighlight?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['Int']>;
  supplierName?: InputMaybe<Scalars['String']>;
  supplierPhoneNumber?: InputMaybe<Scalars['String']>;
  tastingNotesDescription?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  topCta?: InputMaybe<InputUpdateTopCta>;
  typeId?: InputMaybe<ProductType>;
  urlRedirects?: InputMaybe<Array<InputMaybe<InputUpdateUrlRedirect>>>;
  videoLink?: InputMaybe<Scalars['String']>;
  vimeoId?: InputMaybe<Scalars['String']>;
  vismaProductNumber?: InputMaybe<Scalars['String']>;
  vismaSku?: InputMaybe<Scalars['String']>;
  youTubeId?: InputMaybe<Scalars['String']>;
};

export type IsZipcodeDeliverableResponse = {
  __typename?: 'IsZipcodeDeliverableResponse';
  deliveryMethods?: Maybe<Array<Maybe<DeliveryMethodInfo>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  fakeAddress?: Maybe<FakeAddressInfo>;
  isDeliverable?: Maybe<Scalars['Boolean']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  compareAtPriceVismaFormat?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  itemType?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['ID']>;
  productName?: Maybe<Scalars['String']>;
  qtyPriceVismaFormat?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  totalPriceVismaFormat?: Maybe<Scalars['Int']>;
};

export type ListPage = PageInfoInterface & {
  __typename?: 'ListPage';
  objectIds: Array<Maybe<ListPageObjectIds>>;
  storyblok?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  types: Array<Maybe<ListPageTypeTypes>>;
};

export type ListPageObjectIds = {
  __typename?: 'ListPageObjectIds';
  objectId: Scalars['Int'];
  weight: Scalars['Int'];
};

export type ListPageTypeTypes = {
  __typename?: 'ListPageTypeTypes';
  attribute: Scalars['String'];
  name: Scalars['String'];
};

/** Represents a customer order with line items, totals, and delivery information. */
export type MagentoOrder = {
  __typename?: 'MagentoOrder';
  couponCode?: Maybe<Scalars['String']>;
  customerUUID?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryMessage?: Maybe<Scalars['String']>;
  deliveryMethod?: Maybe<Scalars['String']>;
  groupVoucherCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isSuperpay?: Maybe<Scalars['Boolean']>;
  lineItems?: Maybe<Array<Maybe<LineItem>>>;
  maskedCartId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  placed?: Maybe<Scalars['DateTime']>;
  shippingPriceVismaFormat?: Maybe<Scalars['Int']>;
  signedUpForNewsletter?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  taxVismaFormat?: Maybe<Scalars['Int']>;
  /** @deprecated not used anymore */
  ticketsSent?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['String']>;
  totalVismaFormat?: Maybe<Scalars['Int']>;
  userMail?: Maybe<Scalars['String']>;
  webOrderId: Scalars['ID'];
  websiteCode?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Adds a product to the shopping cart for the current session. Requires a valid session (obtained from request headers) and validates that quantity is greater than 0. Accepts productId (internal Magento ID) or vismaId (external ERP identifier) to identify the product. Supports optional customPrice for admin-set pricing, eventSourceName for tracking the add source (e.g., "search", "product-page"), and hitPosition for Algolia analytics. Automatically syncs the cart ID with the session if mismatched. Returns both the updated cart object and a status message indicating success or stock limitations. Throws RuntimeException if quantity is invalid or session is not found. */
  addToCart?: Maybe<AddToCartMutation>;
  /** Updates or modifies a customer product review. */
  adjustCustomerReview?: Maybe<Scalars['String']>;
  /** Adds or removes products from the customer's wishlist. */
  adjustWishlist?: Maybe<Scalars['String']>;
  /** Applies a discount coupon code to the current shopping cart. Validates the coupon code against Magento cart price rules to check if it's valid, active, and applicable to current cart contents. Coupon codes are case-insensitive and automatically trimmed of whitespace. Only one coupon code can be active at a time - applying a new code replaces any existing coupon. Validates usage limits (per customer and total), date ranges, and minimum cart amount requirements. Returns the updated Cart object with the discount reflected in totalDiscount and couponDiscountAmount fields. If the coupon is invalid, expired, or not applicable, throws an exception with specific error message. Requires a valid session to retrieve the current cart. Discount is immediately reflected in cart totals. */
  applyCouponCode?: Maybe<Cart>;
  /** Apply FlexVoucher to the cart */
  applyFlexVoucher?: Maybe<Cart>;
  /** Apply group voucher to the cart */
  applyGroupVoucher?: Maybe<SessionResponse>;
  /** Authenticates a user with email and password credentials and establishes an authenticated session. Validates credentials against Magento customer database and Visma ERP system. If the user has a guest cart (from browsing before login), automatically merges it with their customer cart, preserving all items. Returns AuthenticateResponse containing customer token, session data, cart information, and user profile. Triggers customer login tracking event for analytics, recording success or failure with error details. Updates session with customer's Visma customer ID, enabling customer-specific pricing and features. Throws LocalizedException if credentials are invalid, account is locked, or email is not confirmed. The returned customerToken should be stored and used for subsequent authenticated requests via UpdateSessionWithCustomerTokenMutation. */
  authenticateV2?: Maybe<AuthenticateResponse>;
  /** Changes the password for the authenticated user. */
  changePassword?: Maybe<FormSubmitMessage>;
  /** Confirms a user account registration using verification token. */
  confirmAccount?: Maybe<AuthenticateResponse>;
  /** Creates a new CartAddress */
  createCartAddress?: Maybe<CartAddress>;
  /** Creates a new CartRule */
  createCartRule?: Maybe<CartRule>;
  /** Creates a new Classics */
  createClassics?: Maybe<Classics>;
  /** Creates a new CustomerProfile */
  createCustomerProfile?: Maybe<CustomerProfile>;
  /** Creates a new CustomerProfileAddress */
  createCustomerProfileAddress?: Maybe<CustomerProfileAddress>;
  /** Creates a new Discount */
  createDiscount?: Maybe<Discount>;
  /** Creates a new GroupVoucherCode */
  createGroupVoucherCode?: Maybe<GroupVoucherCode>;
  /** Creates a new PriceTablePricing */
  createPriceTablePricing?: Maybe<PriceTablePricing>;
  /** Creates a new Rating */
  createRating?: Maybe<Rating>;
  /** Creates a new RatingSymbols */
  createRatingSymbols?: Maybe<RatingSymbols>;
  /** Creates a new Reviewer */
  createReviewer?: Maybe<Reviewer>;
  /** Creates a test payment for development and testing purposes. */
  createTestPayment?: Maybe<CreateTestPaymentResult>;
  /** Creates a new Unit */
  createUnit?: Maybe<Unit>;
  /** Creates a new UrlRedirect */
  createUrlRedirect?: Maybe<UrlRedirect>;
  /** Creates a new WineProduct */
  createWineProduct?: Maybe<WineProduct>;
  /** Delete a custom product badge by ID. Requires admin authentication. Returns success status and message. */
  deleteBadge?: Maybe<DeleteBadgeMutationResult>;
  /** Deletes a CartAddress by id */
  deleteCartAddress?: Maybe<Scalars['String']>;
  /** Deletes a CartRule by id */
  deleteCartRule?: Maybe<Scalars['String']>;
  /** Deletes a Classics by id */
  deleteClassics?: Maybe<Scalars['String']>;
  /** Deletes a CustomerProfile by id */
  deleteCustomerProfile?: Maybe<Scalars['String']>;
  /** Deletes a CustomerProfileAddress by id */
  deleteCustomerProfileAddress?: Maybe<Scalars['String']>;
  /** Deletes a Discount by id */
  deleteDiscount?: Maybe<Scalars['String']>;
  /** Deletes a GroupVoucherCode by id */
  deleteGroupVoucherCode?: Maybe<Scalars['String']>;
  /** Deletes a PriceTablePricing by id */
  deletePriceTablePricing?: Maybe<Scalars['String']>;
  /** Deletes a Rating by id */
  deleteRating?: Maybe<Scalars['String']>;
  /** Deletes a RatingSymbols by id */
  deleteRatingSymbols?: Maybe<Scalars['String']>;
  /** Deletes a Reviewer by id */
  deleteReviewer?: Maybe<Scalars['String']>;
  /** Deletes Storyblok cache for one or more story slugs. Used for unpublished pages. Requires admin authentication. */
  deleteStoryblokCache: DeleteStoryblokCacheResponse;
  /** Deletes a Unit by id */
  deleteUnit?: Maybe<Scalars['String']>;
  /** Deletes a UrlRedirect by id */
  deleteUrlRedirect?: Maybe<Scalars['String']>;
  /** Deletes a WineProduct by id */
  deleteWineProduct?: Maybe<Scalars['String']>;
  /** Deletes a WineProduct by vismaId (SKU) */
  deleteWineProductByVismaId?: Maybe<Scalars['Boolean']>;
  /** Tracks HubSpot form submission events. */
  hubSpotFormEvent?: Maybe<Scalars['String']>;
  /** Create an OpenAI completion with custom prompts and parameters (Admin only) */
  openAiCompletion?: Maybe<OpenAiCompletionResult>;
  /** Performs a payment operation (Capture or Refund) for Visma integration. */
  paymentOperation?: Maybe<PaymentOperationResult>;
  /** Places an order from cart id */
  placeOrder?: Maybe<RedirectObject>;
  /** Registers a new customer account and immediately authenticates the user in a single operation. Creates a new customer in both Magento and Visma ERP systems with the provided email, full name, phone, and password. The password parameter is optional - if omitted, the account is created without login credentials (passwordless account). Validates email format and uniqueness - throws HandledException with BadRequest status if email already exists. If the user has a guest cart from browsing, automatically merges it with the new customer account, preserving items. After successful registration, automatically logs in the user and returns AuthenticateResponse with tokens and session data. The emailForOrderConfirmation is used for transactional emails and becomes the account username. Full name is parsed into firstname and lastname for Magento customer entity. Phone number is validated and stored for order notifications and delivery coordination. */
  register?: Maybe<AuthenticateResponse>;
  /** Removes the currently applied coupon code from the shopping cart. Clears any discount associated with the coupon and recalculates cart totals. This mutation takes no parameters - it removes whatever coupon is currently active on the cart. If no coupon is applied, the operation completes successfully with no changes. Returns the updated Cart object with couponCode field set to null and couponDiscountAmount reset to 0. All other discounts (group vouchers, flex vouchers, cart rules) remain unaffected. Requires a valid session to identify the current cart. Typically used when users want to try a different coupon code. */
  removeCouponCodeFromCart?: Maybe<Cart>;
  /** Remove Flex Voucher from the cart */
  removeFlexVoucherFromCart?: Maybe<Cart>;
  /** Removes a specific product from the shopping cart by SKU. Retrieves the current session from request headers and fetches the associated cart. The SKU parameter must match exactly (case-sensitive) with a product in the cart. If the SKU is not found, the operation completes silently without error. Returns the updated Cart object with recalculated totals, discounts, and shipping costs. Automatically removes any applied cart rules or vouchers that are no longer valid after item removal. This mutation is idempotent - calling it multiple times with the same SKU has no additional effect after the first removal. */
  removeFromCart?: Maybe<Cart>;
  /** Remove group voucher from the cart */
  removeGroupVoucherFromCart?: Maybe<SessionResponse>;
  /** Saves a customer note to the cart. */
  saveCustomerNote?: Maybe<Scalars['String']>;
  /** Saves RRWeb session recording data for debugging. */
  saveRRWeb?: Maybe<Scalars['String']>;
  /** Saves complete shipping address information to the cart during checkout. Accepts a data object containing billing and shipping address fields including street, city, postcode, country, phone number, email, firstname, lastname, and company name. Supports sameAsBilling flag to automatically copy billing address to shipping address. Validates address format, postal codes for delivery availability, and required fields based on country. Also saves newsletter subscription preference and other checkout options included in the data object. Returns the updated Cart with populated billingAddress and shippingAddress objects. This is typically the first step in the checkout flow before selecting shipping method. Includes Sentry performance tracing for monitoring save operation timing. */
  saveShippingInfo?: Maybe<Cart>;
  /** Saves the customer's selected shipping method and optional delivery preferences to the cart. The shippingMethod parameter must match a valid carrier code and method code (e.g., "flatrate_flatrate"). Supports optional deliveryDate for scheduled deliveries - validates that the date is in the future and within allowed delivery windows. The deliveryComment parameter allows customers to add special delivery instructions (e.g., "Leave at door", "Ring doorbell"). Automatically calculates and updates shipping costs in the cart totals based on the selected method. Returns the updated Cart object with shippingMethod details populated and totalPrice recalculated to include shipping. This mutation must be called after SaveShippingInfoMutation in the checkout flow. Includes Sentry tracing for performance monitoring. */
  saveShippingMethod?: Maybe<Cart>;
  /** Sends account confirmation email to a user. */
  sendAccountConfirmationEmail?: Maybe<FormSubmitMessage>;
  /** Sends SMS reminder to complete signup process. */
  sendFinishSignupSmsReminder?: Maybe<FormSubmitMessage>;
  /** Sends password reset token via email. */
  sendRpTokenOnEmail?: Maybe<FormSubmitMessage>;
  /** Signs out the currently authenticated user and clears all customer-specific session data. Preserves the session itself but removes customer association, cart ownership, and authentication tokens. The user's cart is disassociated from their account and converted to a guest cart, maintaining items but losing customer-specific pricing. Clears Visma customer ID, customer token, and any personalized data from the session. Returns an updated SessionResponse with new session tokens but no customer information. Does not delete the session entirely - the same session continues as a guest session. Critical for secure logout functionality, ensuring customer data is not accessible after logout. If no user is currently logged in, completes successfully without error. */
  signOutV2?: Maybe<SessionResponse>;
  /** Synchronizes order data to Visma ERP system. */
  syncOrderToVisma?: Maybe<Scalars['String']>;
  /** Tracks purchase events for analytics. */
  trackPurchaseEvent?: Maybe<Scalars['String']>;
  /** Tracks custom analytics events. */
  trackingEvent?: Maybe<Scalars['String']>;
  /** Updates the quantity of a specific cart item identified by SKU. Validates that the requested quantity is greater than 0, throwing RuntimeException if invalid. Checks product availability and automatically adjusts quantity to available stock if requested amount exceeds inventory. If adjusted quantity becomes 0 (out of stock), automatically removes the item from cart entirely. Returns both the updated cart object and a message describing any quantity adjustments or stock limitations. Common messages include stock warnings like "Only X items available" or success confirmations. Recalculates all cart totals, taxes, and applicable discounts after the update. This is the primary mutation for changing item quantities in the cart UI. */
  updateCart?: Maybe<UpdateCartMutation>;
  /** Updates a CartAddress  by id */
  updateCartAddress?: Maybe<CartAddress>;
  /** Updates a CartRule  by id */
  updateCartRule?: Maybe<CartRule>;
  /** Updates a Classics  by id */
  updateClassics?: Maybe<Classics>;
  /** Updating customer */
  updateCustomer?: Maybe<CustomerProfile>;
  /** Updates a CustomerProfile  by id */
  updateCustomerProfile?: Maybe<CustomerProfile>;
  /** Updates a CustomerProfileAddress  by id */
  updateCustomerProfileAddress?: Maybe<CustomerProfileAddress>;
  /** Updates a Discount  by id */
  updateDiscount?: Maybe<Discount>;
  /** Updates a GroupVoucherCode  by id */
  updateGroupVoucherCode?: Maybe<GroupVoucherCode>;
  /** Updates a HubSpot deal record. */
  updateHubspotDeal?: Maybe<Scalars['String']>;
  /** Updates Order status */
  updateOrderStatus?: Maybe<Scalars['String']>;
  /** Updates a PriceTablePricing  by id */
  updatePriceTablePricing?: Maybe<PriceTablePricing>;
  /** Updates a Rating  by id */
  updateRating?: Maybe<Rating>;
  /** Updates a RatingSymbols  by id */
  updateRatingSymbols?: Maybe<RatingSymbols>;
  /** Updates a Reviewer  by id */
  updateReviewer?: Maybe<Reviewer>;
  /** Updates session data by associating a cart ID with the current user session. Retrieves the active session from request context headers (session_id, fpid, or ga_session_id). If no session exists, throws an exception with header details for debugging. Primary use case is syncing cart state between frontend and backend after cart operations. The cartId parameter is optional - pass null to clear the cart association from the session. Returns a SessionResponse object containing updated session details including the new cart ID, session tokens, and tracking identifiers. Critical for maintaining session continuity across requests. */
  updateSession?: Maybe<SessionResponse>;
  /** Associates a customer authentication token with the current session and optionally merges guest cart with customer cart. Creates a new session if none exists for the current request context. The customerToken parameter authenticates the user and links their account to the session. When mergeCart is true, transfers items from the guest cart (identified by cartId) to the customer's persistent cart, updating session data with customer information including their Visma customer ID. If mergeCart is false, simply updates the session with the provided cartId. Returns SessionResponse with updated session tokens, cart ID, and customer identifiers. Essential for login flows and preserving cart contents when users authenticate. Throws LocalizedException if customer token is invalid. */
  updateSessionWithCustomerToken?: Maybe<SessionResponse>;
  /** Updates Storyblok cache for one or more story slugs. Requires admin authentication. */
  updateStoryblokCache: UpdateStoryblokCacheResponse;
  /** Updates Supervin stock */
  updateSupervinStock?: Maybe<Scalars['String']>;
  /** Updates a Unit  by id */
  updateUnit?: Maybe<Unit>;
  /** Updates a UrlRedirect  by id */
  updateUrlRedirect?: Maybe<UrlRedirect>;
  /** Updates a WineProduct  by id */
  updateWineProduct?: Maybe<WineProduct>;
  /** Upsert a custom product badge. Requires admin authentication. Returns badge data as key-value pairs. */
  upsertBadge?: Maybe<UpsertBadgeMutationResult>;
  /** Upsert Campaign */
  upsertCampaign?: Maybe<Scalars['String']>;
  /** Updating or creating a customer based on email as unique key */
  upsertCustomer?: Maybe<Scalars['String']>;
  /** Updating or creating a customer based on email as unique key */
  upsertCustomerV2?: Maybe<CustomerProfile>;
  /** Upsert Group Voucher */
  upsertGroupVoucher?: Maybe<Scalars['String']>;
  /** Upserts WineProduct */
  upsertWineProduct?: Maybe<WineProduct>;
  /** Upserts by SKU a new WineProduct */
  upsertWineProductBySku?: Maybe<WineProduct>;
};


export type MutationAddToCartArgs = {
  customPrice?: InputMaybe<Scalars['Int']>;
  eventSourceName?: InputMaybe<Scalars['String']>;
  hitPosition?: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
  qty: Scalars['Int'];
  vismaId?: InputMaybe<Scalars['String']>;
};


export type MutationAdjustCustomerReviewArgs = {
  productId: Scalars['Int'];
  rating: Scalars['Int'];
  removeReview?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAdjustWishlistArgs = {
  productId: Scalars['Int'];
  removeFromWishlist?: InputMaybe<Scalars['Boolean']>;
};


export type MutationApplyCouponCodeArgs = {
  couponCode: Scalars['String'];
};


export type MutationApplyFlexVoucherArgs = {
  flexVoucherCode: Scalars['String'];
};


export type MutationApplyGroupVoucherArgs = {
  groupVoucherCode: Scalars['String'];
};


export type MutationAuthenticateV2Args = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
  resetToken?: InputMaybe<Scalars['String']>;
};


export type MutationConfirmAccountArgs = {
  confirmationKey: Scalars['String'];
  email: Scalars['String'];
};


export type MutationCreateCartAddressArgs = {
  data: InputCreateCartAddress;
};


export type MutationCreateCartRuleArgs = {
  data: InputCreateCartRule;
};


export type MutationCreateClassicsArgs = {
  data: InputCreateClassics;
};


export type MutationCreateCustomerProfileArgs = {
  data: InputCreateCustomerProfile;
};


export type MutationCreateCustomerProfileAddressArgs = {
  data: InputCreateCustomerProfileAddress;
};


export type MutationCreateDiscountArgs = {
  data: InputCreateDiscount;
};


export type MutationCreateGroupVoucherCodeArgs = {
  data: InputCreateGroupVoucherCode;
};


export type MutationCreatePriceTablePricingArgs = {
  data: InputCreatePriceTablePricing;
};


export type MutationCreateRatingArgs = {
  data: InputCreateRating;
};


export type MutationCreateRatingSymbolsArgs = {
  data: InputCreateRatingSymbols;
};


export type MutationCreateReviewerArgs = {
  data: InputCreateReviewer;
};


export type MutationCreateTestPaymentArgs = {
  amount: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  providerKey?: InputMaybe<Scalars['String']>;
};


export type MutationCreateUnitArgs = {
  data: InputCreateUnit;
};


export type MutationCreateUrlRedirectArgs = {
  data: InputCreateUrlRedirect;
};


export type MutationCreateWineProductArgs = {
  data: InputCreateWineProduct;
};


export type MutationDeleteBadgeArgs = {
  badge_id: Scalars['Int'];
};


export type MutationDeleteCartAddressArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCartRuleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClassicsArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCustomerProfileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCustomerProfileAddressArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDiscountArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGroupVoucherCodeArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePriceTablePricingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRatingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRatingSymbolsArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteReviewerArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStoryblokCacheArgs = {
  slugs: Array<Scalars['String']>;
};


export type MutationDeleteUnitArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUrlRedirectArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWineProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWineProductByVismaIdArgs = {
  vismaId: Scalars['String'];
};


export type MutationHubSpotFormEventArgs = {
  data: Scalars['String'];
  formName: Scalars['String'];
};


export type MutationOpenAiCompletionArgs = {
  model?: InputMaybe<Scalars['String']>;
  responseType?: InputMaybe<Scalars['String']>;
  systemPrompt?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
  userPrompt: Scalars['String'];
};


export type MutationPaymentOperationArgs = {
  amount: Scalars['Int'];
  paymentId: Scalars['String'];
  type: PaymentOperationType;
};


export type MutationPlaceOrderArgs = {
  groupVoucherNewsletter?: InputMaybe<Scalars['Boolean']>;
  newsletter?: InputMaybe<Scalars['Boolean']>;
  paymentMethod: Scalars['String'];
  supervinEventPermission?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRegisterArgs = {
  emailForOrderConfirmation: Scalars['String'];
  fullName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveFlexVoucherFromCartArgs = {
  flexVoucherCode: Scalars['String'];
};


export type MutationRemoveFromCartArgs = {
  sku: Scalars['String'];
};


export type MutationSaveCustomerNoteArgs = {
  customerNote: Scalars['String'];
};


export type MutationSaveRrWebArgs = {
  batch_id: Scalars['Int'];
  events: Scalars['String'];
  hash_map: Scalars['String'];
};


export type MutationSaveShippingInfoArgs = {
  data: InputUpdateCart;
};


export type MutationSaveShippingMethodArgs = {
  deliveryComment?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  shippingMethod: Scalars['String'];
};


export type MutationSendAccountConfirmationEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendFinishSignupSmsReminderArgs = {
  vismaId: Scalars['ID'];
};


export type MutationSendRpTokenOnEmailArgs = {
  email: Scalars['String'];
  type: Scalars['String'];
};


export type MutationSyncOrderToVismaArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  sandbox?: InputMaybe<Scalars['Boolean']>;
  webOrderId: Scalars['String'];
};


export type MutationTrackPurchaseEventArgs = {
  maskedCartId: Scalars['ID'];
};


export type MutationTrackingEventArgs = {
  data: Scalars['String'];
  event: Scalars['String'];
};


export type MutationUpdateCartArgs = {
  qty: Scalars['Int'];
  sku: Scalars['String'];
};


export type MutationUpdateCartAddressArgs = {
  data: InputUpdateCartAddress;
  id: Scalars['ID'];
};


export type MutationUpdateCartRuleArgs = {
  data: InputUpdateCartRule;
  id: Scalars['ID'];
};


export type MutationUpdateClassicsArgs = {
  data: InputUpdateClassics;
  id: Scalars['ID'];
};


export type MutationUpdateCustomerArgs = {
  data: CustomerUpsertV2Input;
};


export type MutationUpdateCustomerProfileArgs = {
  data: InputUpdateCustomerProfile;
  id: Scalars['ID'];
};


export type MutationUpdateCustomerProfileAddressArgs = {
  data: InputUpdateCustomerProfileAddress;
  id: Scalars['ID'];
};


export type MutationUpdateDiscountArgs = {
  data: InputUpdateDiscount;
  id: Scalars['ID'];
};


export type MutationUpdateGroupVoucherCodeArgs = {
  data: InputUpdateGroupVoucherCode;
  id: Scalars['ID'];
};


export type MutationUpdateHubspotDealArgs = {
  dealStageStep: Scalars['Int'];
};


export type MutationUpdateOrderStatusArgs = {
  orderId: Scalars['String'];
  status: OrderStatus;
};


export type MutationUpdatePriceTablePricingArgs = {
  data: InputUpdatePriceTablePricing;
  id: Scalars['ID'];
};


export type MutationUpdateRatingArgs = {
  data: InputUpdateRating;
  id: Scalars['ID'];
};


export type MutationUpdateRatingSymbolsArgs = {
  data: InputUpdateRatingSymbols;
  id: Scalars['ID'];
};


export type MutationUpdateReviewerArgs = {
  data: InputUpdateReviewer;
  id: Scalars['ID'];
};


export type MutationUpdateSessionArgs = {
  cartId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateSessionWithCustomerTokenArgs = {
  cartId?: InputMaybe<Scalars['ID']>;
  customerToken?: InputMaybe<Scalars['String']>;
  mergeCart?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateStoryblokCacheArgs = {
  slugs: Array<Scalars['String']>;
};


export type MutationUpdateSupervinStockArgs = {
  stock: Scalars['Int'];
  vismaId: Scalars['String'];
};


export type MutationUpdateUnitArgs = {
  data: InputUpdateUnit;
  id: Scalars['ID'];
};


export type MutationUpdateUrlRedirectArgs = {
  data: InputUpdateUrlRedirect;
  id: Scalars['ID'];
};


export type MutationUpdateWineProductArgs = {
  data: InputUpdateWineProduct;
  id: Scalars['ID'];
};


export type MutationUpsertBadgeArgs = {
  apply_to_all_products?: InputMaybe<Scalars['Boolean']>;
  badge_html?: InputMaybe<Scalars['String']>;
  badge_id?: InputMaybe<Scalars['Int']>;
  category_ids?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  start_date?: InputMaybe<Scalars['String']>;
  store_id: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertCampaignArgs = {
  campaignName: Scalars['String'];
  vismaIds: Array<InputMaybe<Scalars['String']>>;
};


export type MutationUpsertCustomerArgs = {
  data: CustomerUpsertInput;
  email: Scalars['String'];
};


export type MutationUpsertCustomerV2Args = {
  data: CustomerUpsertV2Input;
  email?: InputMaybe<Scalars['String']>;
  forceCreateFlexposCustomer?: InputMaybe<Scalars['Boolean']>;
  sendFinishSignUpReminder?: InputMaybe<Scalars['Boolean']>;
  vismaId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpsertGroupVoucherArgs = {
  groupVoucher: GroupVoucherCodeInput;
};


export type MutationUpsertWineProductArgs = {
  data: InputUpdateWineProduct;
  vismaId: Scalars['String'];
};


export type MutationUpsertWineProductBySkuArgs = {
  data: InputUpdateWineProduct;
  sku: Scalars['String'];
};

export type NodeBase = {
  body?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  nodePath?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  urlRedirects?: Maybe<Array<Maybe<UrlRedirect>>>;
};

export type NotFoundPage = {
  __typename?: 'NotFoundPage';
  path?: Maybe<Scalars['String']>;
};

export type OpenAiCompletionResult = {
  __typename?: 'OpenAiCompletionResult';
  message?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum OrderStatus {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type PageBreadcrumb = {
  __typename?: 'PageBreadcrumb';
  label: Scalars['String'];
  path: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  actions?: Maybe<Array<Maybe<Actions>>>;
  breadcrumb?: Maybe<Array<Maybe<PageBreadcrumb>>>;
  breadcrumbStyle: Scalars['String'];
  context?: Maybe<Array<Maybe<Context>>>;
  head?: Maybe<Head>;
  id?: Maybe<Scalars['String']>;
  pageData?: Maybe<PageInfoData>;
  path?: Maybe<Scalars['String']>;
  redirect?: Maybe<Redirect>;
  type?: Maybe<PageInfoType>;
};

export type PageInfoData = ListPage | NotFoundPage | ProductPage | Storyblok;

export type PageInfoInterface = {
  storyblok?: Maybe<Scalars['String']>;
};

export enum PageInfoType {
  ListPage = 'LIST_PAGE',
  NotFound = 'NOT_FOUND',
  ProductPage = 'PRODUCT_PAGE',
  SearchPageInfo = 'SEARCH_PAGE_INFO',
  StoryblokPage = 'STORYBLOK_PAGE'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  description?: Maybe<Scalars['String']>;
  icons?: Maybe<Array<Maybe<Image>>>;
  id?: Maybe<Scalars['ID']>;
  method?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PaymentOperationResult = {
  __typename?: 'PaymentOperationResult';
  data?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum PaymentOperationType {
  /** Capture a payment */
  Capture = 'CAPTURE',
  /** Refund a payment */
  Refund = 'REFUND'
}

export type PriceTable = {
  __typename?: 'PriceTable';
  /** @deprecated Use defaultQuantity on the product instead */
  defaultQuantity?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pricings?: Maybe<Array<Maybe<PriceTablePricing>>>;
  productId?: Maybe<Scalars['Int']>;
};

export type PriceTablePricing = {
  __typename?: 'PriceTablePricing';
  amount: Scalars['Int'];
  amountIncVat?: Maybe<Scalars['Int']>;
  discount?: Maybe<Discount>;
  id?: Maybe<Scalars['String']>;
  maxQty?: Maybe<Scalars['Int']>;
  minQty?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  websiteCode?: Maybe<Scalars['String']>;
};

export type Producer = {
  __typename?: 'Producer';
  address?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryIcon?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  urlKey?: Maybe<Scalars['String']>;
  vismaId?: Maybe<Scalars['String']>;
};

export type ProducerV2 = {
  __typename?: 'ProducerV2';
  contentImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  urlPath?: Maybe<Scalars['String']>;
};

export type ProductAuthor = {
  __typename?: 'ProductAuthor';
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
};

export type ProductBase = {
  canBeAddedToCart?: Maybe<Scalars['Boolean']>;
  costPrice?: Maybe<Scalars['Int']>;
  ctaHidePrice?: Maybe<Scalars['Boolean']>;
  ctaLink?: Maybe<Scalars['String']>;
  ctaStockText?: Maybe<Scalars['String']>;
  ctaTitle?: Maybe<Scalars['String']>;
  defaultQuantity?: Maybe<Scalars['Int']>;
  highlightExpireDate?: Maybe<Scalars['String']>;
  highlightText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use 'images' instead */
  image?: Maybe<Image>;
  inStock?: Maybe<Scalars['Boolean']>;
  isTicketsEnabled?: Maybe<Scalars['Boolean']>;
  preorderDate?: Maybe<Scalars['String']>;
  priceTable: PriceTable;
  producerDescription?: Maybe<Scalars['String']>;
  productDescription?: Maybe<Scalars['String']>;
  productionMethodDescription?: Maybe<Scalars['String']>;
  shortText?: Maybe<Scalars['String']>;
  showHighlight?: Maybe<Scalars['Boolean']>;
  sku: Scalars['String'];
  /** @deprecated Use published instead */
  status?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Int']>;
  tastingNotesDescription?: Maybe<Scalars['String']>;
  videoLink?: Maybe<Scalars['String']>;
};

export type ProductImageBadge = {
  __typename?: 'ProductImageBadge';
  badgeColor?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Represents a product page with SEO metadata and structured data. */
export type ProductPage = PageInfoInterface & {
  __typename?: 'ProductPage';
  product?: Maybe<WineProduct>;
  storyblok?: Maybe<Scalars['String']>;
};

export type ProductTag = {
  __typename?: 'ProductTag';
  altText?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum ProductType {
  Giftcard = 'GIFTCARD',
  Simple = 'SIMPLE',
  Virtual = 'VIRTUAL'
}

export type Query = {
  __typename?: 'Query';
  _service?: Maybe<_Service>;
  /** Get a list of Algolia filters */
  getAlgoliaFiltersAndSorts?: Maybe<AlgoliaFiltersAndSorts>;
  /** Returns all of CartAddress */
  getAllCartAddress?: Maybe<GetAllCartAddress>;
  /** Returns all of CartRule */
  getAllCartRule?: Maybe<GetAllCartRule>;
  /** Returns all of Classics */
  getAllClassics?: Maybe<GetAllClassics>;
  /** Returns all of CustomerProfile */
  getAllCustomerProfile?: Maybe<GetAllCustomerProfile>;
  /** Returns all of CustomerProfileAddress */
  getAllCustomerProfileAddress?: Maybe<GetAllCustomerProfileAddress>;
  /** Returns all of Discount */
  getAllDiscount?: Maybe<GetAllDiscount>;
  /** Returns all of GroupVoucherCode */
  getAllGroupVoucherCode?: Maybe<GetAllGroupVoucherCode>;
  /** Returns all of PriceTablePricing */
  getAllPriceTablePricing?: Maybe<GetAllPriceTablePricing>;
  /** Returns all of Rating */
  getAllRating?: Maybe<GetAllRating>;
  /** Returns all of RatingSymbols */
  getAllRatingSymbols?: Maybe<GetAllRatingSymbols>;
  /** Returns all of Reviewer */
  getAllReviewer?: Maybe<GetAllReviewer>;
  /** Returns all of Unit */
  getAllUnit?: Maybe<GetAllUnit>;
  /** Returns all of UrlRedirect */
  getAllUrlRedirect?: Maybe<GetAllUrlRedirect>;
  /** Returns all of WineProduct */
  getAllWineProduct?: Maybe<GetAllWineProduct>;
  /** Retrieves the current shopping cart for the active session. */
  getCart?: Maybe<Cart>;
  /** Looks up city name and information for a given zipcode. */
  getCityByZipcode?: Maybe<Scalars['String']>;
  /** Retrieves customer information by their unique UUID identifier. */
  getCustomerByUuid?: Maybe<CustomerProfile>;
  /** Retrieves customer information by their Visma ID. */
  getCustomerByVismaId?: Maybe<CustomerProfile>;
  /** Retrieves customer reviews for products. */
  getCustomerReviews?: Maybe<Array<Maybe<CustomerReview>>>;
  /** Looks up a customer's UUID using their email address. */
  getCustomerUuidByEmail?: Maybe<Scalars['String']>;
  /** Get group voucher by group voucher code */
  getGroupVoucherByCode?: Maybe<GroupVoucherCode>;
  /** Get group voucher from the cart */
  getGroupVoucherFromCart?: Maybe<GroupVoucherCode>;
  /** Retrieves HubSpot contact information using Visma customer ID. */
  getHubspotContactByVismaId?: Maybe<HubspotContact>;
  /** Retrieves a Magento order by order ID. */
  getMagentoOrder?: Maybe<MagentoOrder>;
  /** Retrieves a list of orders for the current customer. */
  getOrders?: Maybe<Array<Maybe<MagentoOrder>>>;
  /** Retrieves comprehensive page information and metadata for any URL path in the Supervin store. This query determines the page type (product, search, Storyblok content, wine type redirect, or group voucher) and returns appropriate structured data including SEO metadata, breadcrumbs, and page-specific content. It checks for redirects first, then iterates through registered page converters to match the path. Returns a 404 page info object with Storyblok content if no match is found. Supports optional secret key parameter for accessing unpublished content. */
  getPageInfo?: Maybe<PageInfo>;
  /** Retrieves payment data by payment ID for admin users (returns JSON string). */
  getPayment?: Maybe<Scalars['String']>;
  /** Retrieves available payment methods for checkout. */
  getPaymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  /** Retrieves product information by URL path. */
  getProductByPath?: Maybe<WineProduct>;
  /** Retrieves a single wine product by its Visma ERP product ID. Returns null if the product does not exist or is unpublished (unless accessed by admin). For secret products, requires either admin authentication or a matching secretKey parameter. Throws UnauthenticatedException if attempting to access a secret product without proper authorization. This is the primary query for fetching product details by the external Visma identifier. */
  getProductByVismaId?: Maybe<WineProduct>;
  /**
   * Retrieves multiple products by their IDs.
   * @deprecated Use GetProductsByVismaIdsQuery instead
   */
  getProductsByIds?: Maybe<Array<Maybe<WineProduct>>>;
  /** Retrieves multiple wine products by their Visma ERP product IDs in a single batch request. Accepts an array of Visma IDs and returns products in the same order as the input IDs. Only returns published products unless accessed by admin. Throws HandledException with UNAUTHORIZED status if any secret product is accessed without admin authentication. Non-existent IDs are silently skipped in the response. This query is optimized for bulk product fetching with 30-minute cache TTL. */
  getProductsByVismaIds?: Maybe<Array<Maybe<WineProduct>>>;
  /** Retrieves the current user session information. */
  getSession?: Maybe<SessionResponse>;
  /** Retrieves available shipping methods for the cart. */
  getShippingMethods?: Maybe<Array<Maybe<ShippingMethod>>>;
  /** Generates sitemap data for SEO purposes. */
  getSitemap?: Maybe<Array<Maybe<SitemapEntry>>>;
  /** Retrieves store configuration settings. */
  getStoreConfig: StoreConfig;
  /** Retrieves authentication token for Storyblok preview content. */
  getStoryblokPreviewToken?: Maybe<StoryblokPreviewToken>;
  /** Retrieves detailed order information from Visma system. */
  getVismaOrderDetails?: Maybe<VismaOrderDetail>;
  /** Retrieves detailed order information from Visma system (version 2 with enhanced data). */
  getVismaOrderDetailsV2?: Maybe<VismaOrderDetailV2>;
  /** Retrieves customer order history from Visma system. */
  getVismaOrderHistory: VismaOrderListPagination;
  /** Retrieves order history from Visma for a specific customer ID. */
  getVismaOrderHistoryByVismaCustomerId: VismaOrderListV2Pagination;
  /** Retrieves customer order history from Visma system (version 2 with enhanced data). */
  getVismaOrderHistoryV2: VismaOrderListV2Pagination;
  /** Retrieves wine festival event information by URL key. */
  getWineFestivalEvent?: Maybe<WineFestivalEvent>;
  /** Retrieves wine festival table details including products. */
  getWineFestivalTable?: Maybe<Table>;
  /** Retrieves the customer's wishlist. */
  getWishlist?: Maybe<Array<Maybe<WineProduct>>>;
  /** Checks if delivery is available for a given postcode. */
  isPostcodeDeliverable?: Maybe<IsZipcodeDeliverableResponse>;
  /** Validates a password reset token. */
  isRpTokenValid?: Maybe<Scalars['Boolean']>;
};


export type QueryGetAllCartAddressArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllCartRuleArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllClassicsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllCustomerProfileArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllCustomerProfileAddressArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllDiscountArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllGroupVoucherCodeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllPriceTablePricingArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllRatingArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllRatingSymbolsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllReviewerArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllUnitArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllUrlRedirectArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllWineProductArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCityByZipcodeArgs = {
  countryCode: Scalars['String'];
  zipcode: Scalars['String'];
};


export type QueryGetCustomerByUuidArgs = {
  uuid?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCustomerByVismaIdArgs = {
  vismaId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCustomerUuidByEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetGroupVoucherByCodeArgs = {
  groupVoucherCode: Scalars['String'];
};


export type QueryGetHubspotContactByVismaIdArgs = {
  vismaId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetMagentoOrderArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrdersArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endDate: Scalars['DateTime'];
  productSkus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate: Scalars['DateTime'];
  vismaProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGetPageInfoArgs = {
  path: Scalars['String'];
  secret?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaymentArgs = {
  paymentId?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductByPathArgs = {
  path: Scalars['String'];
  secretKey?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductByVismaIdArgs = {
  id: Scalars['ID'];
  secretKey?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductsByIdsArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type QueryGetProductsByVismaIdsArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type QueryGetSessionArgs = {
  sessionSplitTests?: InputMaybe<Scalars['String']>;
};


export type QueryGetShippingMethodsArgs = {
  overrideCurrentDateAndTime?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetStoryblokPreviewTokenArgs = {
  space_id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetVismaOrderDetailsArgs = {
  vismaOrderNumber?: InputMaybe<Scalars['Int']>;
};


export type QueryGetVismaOrderDetailsV2Args = {
  vismaOrderNumber: Scalars['Int'];
};


export type QueryGetVismaOrderHistoryArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetVismaOrderHistoryByVismaCustomerIdArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  vismaCustomerId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetVismaOrderHistoryV2Args = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetWineFestivalEventArgs = {
  urlKey: Scalars['String'];
};


export type QueryGetWineFestivalTableArgs = {
  eventUrlKey: Scalars['String'];
  tableNumber: Scalars['Int'];
};


export type QueryIsPostcodeDeliverableArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  postcode: Scalars['String'];
};


export type QueryIsRpTokenValidArgs = {
  email: Scalars['String'];
  resetToken: Scalars['String'];
};

export type Rating = {
  __typename?: 'Rating';
  hideReview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isPreviousVintage?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  /** Value can only be within '1-6' */
  maxRatingSymbols?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['ID']>;
  rating?: Maybe<Scalars['Int']>;
  /** Value can only be within '1-6' or '80-100' */
  ratingPoint?: Maybe<Scalars['String']>;
  ratingSortWeight?: Maybe<Scalars['Int']>;
  review?: Maybe<Scalars['String']>;
  reviewSnippet?: Maybe<Scalars['String']>;
  reviewer?: Maybe<Reviewer>;
  starCount?: Maybe<Scalars['Int']>;
  symbol?: Maybe<RatingSymbols>;
};

export type RatingSymbols = TaxonomyBase & {
  __typename?: 'RatingSymbols';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['ID']>;
  path?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  vismaReference?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
};

export type Redirect = {
  __typename?: 'Redirect';
  code?: Maybe<Scalars['Int']>;
  redirect?: Maybe<Scalars['String']>;
};

export type RedirectObject = {
  __typename?: 'RedirectObject';
  order?: Maybe<MagentoOrder>;
  redirectUrl?: Maybe<Scalars['String']>;
};

export type Reviewer = TaxonomyBase & {
  __typename?: 'Reviewer';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isVisibleOnline?: Maybe<Scalars['Boolean']>;
  machineName?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['ID']>;
  path?: Maybe<Scalars['String']>;
  ratingType?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  vismaReference?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
};

export type SessionResponse = {
  __typename?: 'SessionResponse';
  cart?: Maybe<Cart>;
  customerProfile?: Maybe<CustomerProfile>;
  groupVoucher?: Maybe<GroupVoucherCode>;
  /** Session ID */
  id?: Maybe<Scalars['ID']>;
  userSession?: Maybe<UserSession>;
};

export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  carrier?: Maybe<Scalars['String']>;
  carrier_logo?: Maybe<Scalars['String']>;
  carrier_title?: Maybe<Scalars['String']>;
  deliveryComment?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dontDeliverDates?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  fastestDeliveryDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  priceDescription?: Maybe<Scalars['String']>;
  showCustomDatePicker?: Maybe<Scalars['Boolean']>;
  showWhereToLeavePackage?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type SitemapEntry = {
  __typename?: 'SitemapEntry';
  changeFreq?: Maybe<Scalars['String']>;
  hreflang?: Maybe<Array<Maybe<HeadLink>>>;
  lastmod?: Maybe<Scalars['DateTime']>;
  path?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type StoreConfig = {
  __typename?: 'StoreConfig';
  ageIdServiceImageUrl: Scalars['String'];
  ageRestrictionsBannerUrl: Scalars['String'];
  algoliaAppId: Scalars['String'];
  algoliaDefaultIndex: Scalars['String'];
  algoliaReadonlyApiKey: Scalars['String'];
  currencyCode: Scalars['String'];
  currencyText: Scalars['String'];
  freeDeliveryStartsFrom: Scalars['Float'];
  id: Scalars['ID'];
  minimumFreightPrice: Scalars['Float'];
  trustImageUrl?: Maybe<Scalars['String']>;
  trustLink?: Maybe<Scalars['String']>;
};

export type Storyblok = PageInfoInterface & {
  __typename?: 'Storyblok';
  storyblok?: Maybe<Scalars['String']>;
};

export type StoryblokCacheDeleteResult = {
  __typename?: 'StoryblokCacheDeleteResult';
  message: Scalars['String'];
  slug: Scalars['String'];
  success: Scalars['Boolean'];
};

export type StoryblokCacheUpdateResult = {
  __typename?: 'StoryblokCacheUpdateResult';
  message: Scalars['String'];
  slug: Scalars['String'];
  success: Scalars['Boolean'];
};

export type StoryblokPreviewToken = {
  __typename?: 'StoryblokPreviewToken';
  accessToken?: Maybe<Scalars['String']>;
};

export type Table = {
  __typename?: 'Table';
  area?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryIcon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  producer?: Maybe<Producer>;
  products?: Maybe<Array<Maybe<TableProductType>>>;
};

export type TableProductType = {
  __typename?: 'TableProductType';
  id?: Maybe<Scalars['ID']>;
  number?: Maybe<Scalars['String']>;
  product?: Maybe<WineProduct>;
};

export type TastingNote = {
  __typename?: 'TastingNote';
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  path?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type TaxonomyBase = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['ID']>;
  path?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  vismaReference?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
};

export type TopCta = {
  __typename?: 'TopCta';
  icon?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Unit = AttributeBase & {
  __typename?: 'Unit';
  id?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateStoryblokCacheResponse = {
  __typename?: 'UpdateStoryblokCacheResponse';
  failedCount: Scalars['Int'];
  results?: Maybe<Array<Maybe<StoryblokCacheUpdateResult>>>;
  success: Scalars['Boolean'];
  successCount: Scalars['Int'];
  totalProcessed: Scalars['Int'];
};

export type UpsertBadgeMutationResult = {
  __typename?: 'UpsertBadgeMutationResult';
  apply_to_all_products?: Maybe<Scalars['Boolean']>;
  badge_html?: Maybe<Scalars['String']>;
  badge_id?: Maybe<Scalars['Int']>;
  category_ids?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  start_date?: Maybe<Scalars['String']>;
  store_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type UrlRedirect = {
  __typename?: 'UrlRedirect';
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  redirect?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** Represents an active user session with tracking and cart data. */
export type UserSession = {
  __typename?: 'UserSession';
  algoliaId?: Maybe<Scalars['String']>;
  cartId?: Maybe<Scalars['String']>;
  cookieConsent?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstUtm?: Maybe<Scalars['String']>;
  gaSessionId?: Maybe<Scalars['String']>;
  gclid?: Maybe<Scalars['String']>;
  latestFbClid?: Maybe<Scalars['String']>;
  latestUserAgent?: Maybe<Scalars['String']>;
  latestUtm?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['ID']>;
  superpayId?: Maybe<Scalars['String']>;
  /** A key-value array of test cases, used for A/B testing */
  testCases?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VismaOrderAddress = {
  __typename?: 'VismaOrderAddress';
  deliveryAddress?: Maybe<Scalars['String']>;
  deliveryCity?: Maybe<Scalars['String']>;
  deliveryCountryCode?: Maybe<Scalars['String']>;
  deliveryZip?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
};

export type VismaOrderDeliveryData = {
  __typename?: 'VismaOrderDeliveryData';
  deliveryAddress?: Maybe<VismaOrderAddress>;
  deliveryComment?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryMethod?: Maybe<Scalars['String']>;
  deliveryName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  trackAndTraceLink?: Maybe<Scalars['String']>;
};

export type VismaOrderDetail = VismaOrderInterface & {
  __typename?: 'VismaOrderDetail';
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerAddressLine1?: Maybe<Scalars['String']>;
  customerAddressLine2?: Maybe<Scalars['String']>;
  customerAddressLine3?: Maybe<Scalars['String']>;
  customerCity?: Maybe<Scalars['String']>;
  customerCountryNumber?: Maybe<Scalars['Int']>;
  customerEanNumber?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerPhone?: Maybe<Scalars['String']>;
  customerType?: Maybe<Scalars['Int']>;
  customerZipCode?: Maybe<Scalars['String']>;
  deliveryAddressLine1?: Maybe<Scalars['String']>;
  deliveryAddressLine2?: Maybe<Scalars['String']>;
  deliveryAddressLine3?: Maybe<Scalars['String']>;
  deliveryCity?: Maybe<Scalars['String']>;
  deliveryComment?: Maybe<Scalars['String']>;
  deliveryCountryNumber?: Maybe<Scalars['Int']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryName?: Maybe<Scalars['String']>;
  deliveryZipCode?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  finishedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  invoiceDate?: Maybe<Scalars['DateTime']>;
  lines: Array<VismaOrderLine>;
  orderStatus: Scalars['ID'];
  totalWithVat: Scalars['ID'];
  vatTotal?: Maybe<Scalars['Int']>;
  vismaOrderNumber: Scalars['ID'];
  webOrderId?: Maybe<Scalars['ID']>;
};

export type VismaOrderDetailV2 = {
  __typename?: 'VismaOrderDetailV2';
  deliveryData?: Maybe<VismaOrderDeliveryData>;
  deliveryPrice?: Maybe<Scalars['Int']>;
  discounts?: Maybe<Array<Maybe<VismaOrderDiscountV2>>>;
  id: Scalars['ID'];
  invoiceData?: Maybe<VismaOrderInvoiceData>;
  invoiceFile?: Maybe<VismaOrderInvoiceFile>;
  orderComment?: Maybe<Scalars['String']>;
  orderDate?: Maybe<Scalars['DateTime']>;
  orderLines?: Maybe<Array<Maybe<VismaOrderLineV2>>>;
  orderStatus?: Maybe<Scalars['String']>;
  orderTotal?: Maybe<Scalars['Int']>;
  storeName?: Maybe<Scalars['String']>;
  vatTotal?: Maybe<Scalars['Int']>;
  vismaOrderNumber: Scalars['ID'];
  visualOrderId: Scalars['ID'];
};

export type VismaOrderDiscountV2 = {
  __typename?: 'VismaOrderDiscountV2';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type VismaOrderInterface = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  orderStatus: Scalars['ID'];
  totalWithVat: Scalars['ID'];
  vismaOrderNumber: Scalars['ID'];
  webOrderId?: Maybe<Scalars['ID']>;
};

export type VismaOrderInvoiceData = {
  __typename?: 'VismaOrderInvoiceData';
  companyName?: Maybe<Scalars['String']>;
  customerAddress?: Maybe<Scalars['String']>;
  customerCity?: Maybe<Scalars['String']>;
  customerCountryCode?: Maybe<Scalars['String']>;
  customerEanNumber?: Maybe<Scalars['Int']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerNumber?: Maybe<Scalars['Int']>;
  customerPhone?: Maybe<Scalars['String']>;
  customerType?: Maybe<Scalars['Int']>;
  customerZip?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  invoiceDate?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
};

export type VismaOrderInvoiceFile = {
  __typename?: 'VismaOrderInvoiceFile';
  id: Scalars['ID'];
  invoiceNumber: Scalars['ID'];
  invoiceUrl?: Maybe<Scalars['String']>;
};

export type VismaOrderLine = {
  __typename?: 'VismaOrderLine';
  id: Scalars['ID'];
  lineNumber: Scalars['Int'];
  productType?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalWithVat?: Maybe<Scalars['Int']>;
  unitPriceWithVat?: Maybe<Scalars['Int']>;
  unitVat?: Maybe<Scalars['Int']>;
  vatTotal?: Maybe<Scalars['Int']>;
  vismaOrderNumber: Scalars['ID'];
  vismaProductNumber: Scalars['ID'];
};

export type VismaOrderLineV2 = {
  __typename?: 'VismaOrderLineV2';
  id: Scalars['ID'];
  lineNumber: Scalars['Int'];
  lineTotal?: Maybe<Scalars['Int']>;
  productImage?: Maybe<Image>;
  productTitle?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Int']>;
  unitType?: Maybe<Scalars['String']>;
  vismaOrderNumber: Scalars['ID'];
  vismaProductNumber: Scalars['ID'];
};

export type VismaOrderList = VismaOrderInterface & {
  __typename?: 'VismaOrderList';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  orderStatus: Scalars['ID'];
  totalWithVat: Scalars['ID'];
  vismaOrderNumber: Scalars['ID'];
  webOrderId?: Maybe<Scalars['ID']>;
};

export type VismaOrderListPagination = {
  __typename?: 'VismaOrderListPagination';
  items: Array<VismaOrderList>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type VismaOrderListV2Pagination = {
  __typename?: 'VismaOrderListV2Pagination';
  items: Array<VismaOrderDetailV2>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type VoucherAddress = {
  deliveryAddress: Scalars['String'];
  deliveryCity: Scalars['String'];
  deliveryCompanyName?: InputMaybe<Scalars['String']>;
  deliveryCountry?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  deliveryName: Scalars['String'];
  deliveryStreetFloor?: InputMaybe<Scalars['String']>;
  deliveryZip: Scalars['String'];
};

export type VoucherProduct = {
  discountPrice: Scalars['Int'];
  vismaId: Scalars['String'];
};

export type WineFestivalEvent = {
  __typename?: 'WineFestivalEvent';
  address?: Maybe<Scalars['String']>;
  algoliaIndex?: Maybe<Scalars['String']>;
  discountPagePath?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  mapImage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  tables?: Maybe<Array<Maybe<Table>>>;
  urlKey?: Maybe<Scalars['String']>;
};

export type WineMeta = {
  __typename?: 'WineMeta';
  acidContent?: Maybe<Scalars['Int']>;
  alcohol?: Maybe<Scalars['String']>;
  allergens?: Maybe<Array<Maybe<Scalars['String']>>>;
  area?: Maybe<Scalars['String']>;
  areaEnt?: Maybe<Area>;
  attributes?: Maybe<Array<Maybe<Attribute>>>;
  barrelTypes?: Maybe<Array<Maybe<Barrel>>>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  classics?: Maybe<Array<Maybe<Classics>>>;
  contentLabel?: Maybe<Scalars['String']>;
  contents?: Maybe<Scalars['String']>;
  contentsCl?: Maybe<Scalars['Int']>;
  countryEnt?: Maybe<Country>;
  countryName?: Maybe<Scalars['String']>;
  districtEnt?: Maybe<District>;
  districtName?: Maybe<Scalars['String']>;
  energyLabel?: Maybe<Scalars['String']>;
  energyLabelDoc?: Maybe<Scalars['String']>;
  foods?: Maybe<Array<Maybe<Food>>>;
  grapes?: Maybe<Array<Maybe<Scalars['String']>>>;
  grapesV2?: Maybe<Array<Maybe<Grape>>>;
  id?: Maybe<Scalars['ID']>;
  measurementUnit?: Maybe<Scalars['String']>;
  nutritionalInfoUrl?: Maybe<Scalars['String']>;
  portType?: Maybe<Scalars['String']>;
  powerLabel?: Maybe<Scalars['String']>;
  powerValue?: Maybe<Scalars['Int']>;
  producer?: Maybe<ProducerV2>;
  producerName?: Maybe<Scalars['String']>;
  productDataSheet?: Maybe<Scalars['String']>;
  productSubType?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  ratings?: Maybe<Array<Maybe<Rating>>>;
  residualSugar?: Maybe<Scalars['Int']>;
  savingPotential?: Maybe<Scalars['String']>;
  serving?: Maybe<Scalars['String']>;
  subDistrictName?: Maybe<Scalars['String']>;
  sweetnessLabel?: Maybe<Scalars['String']>;
  sweetnessValue?: Maybe<Scalars['Int']>;
  tastingNotes?: Maybe<Array<Maybe<TastingNote>>>;
  unit?: Maybe<Scalars['String']>;
  units?: Maybe<Unit>;
  vintage?: Maybe<Scalars['Int']>;
  wineBodyLabel?: Maybe<Scalars['String']>;
  wineBodyValue?: Maybe<Scalars['Int']>;
  wineType?: Maybe<Scalars['String']>;
};

/** Represents a wine product in the catalog with detailed attributes and metadata. */
export type WineProduct = NodeBase & ProductBase & {
  __typename?: 'WineProduct';
  availableFrom?: Maybe<Scalars['DateTime']>;
  baPercentage?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  canBeAddedToCart?: Maybe<Scalars['Boolean']>;
  closure?: Maybe<Scalars['String']>;
  costPrice?: Maybe<Scalars['Int']>;
  ctaHidePrice?: Maybe<Scalars['Boolean']>;
  ctaLink?: Maybe<Scalars['String']>;
  ctaStockText?: Maybe<Scalars['String']>;
  ctaTitle?: Maybe<Scalars['String']>;
  customBadgeHTML?: Maybe<Scalars['String']>;
  defaultQuantity?: Maybe<Scalars['Int']>;
  has360BottleImage?: Maybe<Scalars['Boolean']>;
  has360BoxImage?: Maybe<Scalars['Boolean']>;
  hideDiscountCountdown?: Maybe<Scalars['Boolean']>;
  hidePriceTable?: Maybe<Scalars['Boolean']>;
  hideReview?: Maybe<Scalars['Boolean']>;
  hideShippingCountdown?: Maybe<Scalars['Boolean']>;
  hideSupervinAdvantages?: Maybe<Scalars['Boolean']>;
  highlightExpireDate?: Maybe<Scalars['String']>;
  highlightText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use 'images' instead */
  image?: Maybe<Image>;
  images?: Maybe<Array<Maybe<Image>>>;
  inStock?: Maybe<Scalars['Boolean']>;
  isB2b?: Maybe<Scalars['Boolean']>;
  isBundleProduct?: Maybe<Scalars['Boolean']>;
  isEnPrimeur?: Maybe<Scalars['Boolean']>;
  isLeftover?: Maybe<Scalars['Boolean']>;
  isSecret?: Maybe<Scalars['Boolean']>;
  isTicketsEnabled?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<WineMeta>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  minimumQuantity?: Maybe<Scalars['String']>;
  nodePath?: Maybe<Scalars['String']>;
  nonAlcoholic?: Maybe<Scalars['Boolean']>;
  organic?: Maybe<Scalars['Boolean']>;
  packaging?: Maybe<Scalars['String']>;
  pageWhitelist?: Maybe<Array<Maybe<Scalars['String']>>>;
  pdfText?: Maybe<Scalars['String']>;
  preorderDate?: Maybe<Scalars['String']>;
  priceTable: PriceTable;
  producerDescription?: Maybe<Scalars['String']>;
  productAuthor?: Maybe<ProductAuthor>;
  productDescription?: Maybe<Scalars['String']>;
  productImageBadge?: Maybe<ProductImageBadge>;
  productionMethodDescription?: Maybe<Scalars['String']>;
  promoteFrontPage?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedWebsites?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchSortWeight?: Maybe<Scalars['String']>;
  searchWords?: Maybe<Scalars['String']>;
  secretKey?: Maybe<Scalars['String']>;
  shortText?: Maybe<Scalars['String']>;
  showHighlight?: Maybe<Scalars['Boolean']>;
  sku: Scalars['String'];
  /** @deprecated Use published instead */
  status?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Int']>;
  suggestedRetailPrice?: Maybe<Scalars['String']>;
  supplierName?: Maybe<Scalars['String']>;
  supplierPhoneNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<ProductTag>>>;
  tastingNotesDescription?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  topCta?: Maybe<TopCta>;
  typeId?: Maybe<ProductType>;
  urlRedirects?: Maybe<Array<Maybe<UrlRedirect>>>;
  videoLink?: Maybe<Scalars['String']>;
  vimeoId?: Maybe<Scalars['String']>;
  vismaProductNumber: Scalars['String'];
  vismaSku?: Maybe<Scalars['String']>;
  youTubeId?: Maybe<Scalars['String']>;
};

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']>;
};

export type UpdateCartMutation = {
  __typename?: 'updateCartMutation';
  cart?: Maybe<Cart>;
  message?: Maybe<Scalars['String']>;
};
